/* ENGRAM · fluxo de personalização (ecrãs 1e / 1f / 1j) — sections/engram-flow.liquid.
   Modal por passos: fotografia (ou gravação) → oferta → extras → rever → adicionado. Abre com «engram:flow:open» (assets/engram-pdp.js).
   A fotografia (e o desenho a gravar) é da app UploadKit: a app desenha o seu uploader dentro do <div class="uploadkit"> do modal
   e cria os <input name="properties[…]"> com o link; aqui só se mostram os estados à volta e se copiam essas propriedades tal
   como estão. A gravação (1f) escreve as propriedades do atelier (Tipo de gravação, Texto a gravar, Lugar, Coordenadas,
   e o kit da impressão digital); a gravação no verso e o kit de impressão digital são linhas próprias, como os extras.
   O saco actualiza-se pelo cart-drawer do tema (getSectionsToRender/renderContents), sem reimplementar. */
(function () {
  if (window.__engramFlow) return;
  window.__engramFlow = true;

  var MOBILE = window.matchMedia('(max-width: 989px)');
  var STORE_PREFIX = 'engram-flow:';

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  function readJson(selector) {
    var el = document.querySelector(selector);
    try { return el ? JSON.parse(el.textContent) : null; } catch (e) { return null; }
  }

  function fill(template, values) {
    return String(template || '').replace(/\[(\w+)\]/g, function (m, key) { return key in values ? values[key] : m; });
  }

  /* formato de preço da loja (shop.money_format), como o filtro money do Liquid */
  function money(cents, format) {
    var value = (parseInt(cents, 10) || 0) / 100;
    var out = format || '€{{amount_with_comma_separator}}';
    var m = out.match(/\{\{\s*(\w+)\s*\}\}/);
    var kind = m ? m[1] : 'amount';
    var decimals = /no_decimals/.test(kind) ? 0 : 2;
    var thousands = /comma_separator|space_separator|apostrophe_separator/.test(kind) ? '.' : ',';
    var decimal = /comma_separator/.test(kind) ? ',' : '.';
    if (/space_separator/.test(kind)) thousands = ' ';
    if (/apostrophe_separator/.test(kind)) thousands = "'";
    var fixed = value.toFixed(decimals).split('.');
    var int = fixed[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    var number = decimals ? int + decimal + fixed[1] : int;
    return out.replace(/\{\{\s*\w+\s*\}\}/, number);
  }

  /* entrega estimada: hoje + dias úteis (assets/engram-dates.js: feriados e hora de corte) */
  function leadRange(min, max, locale) {
    return window.EngramDates ? EngramDates.range(min, max, locale) : '';
  }

  function init(root) {
    var productId = root.getAttribute('data-engram-flow');
    var config = readJson('[data-engram-flow-config="' + productId + '"]');
    var strings = readJson('[data-engram-flow-strings="' + productId + '"]') || {};
    if (!config) return;

    /* ENGRAM · medição: os sinais do fluxo vão para o Google Tag Manager (snippets/engram-gtm) pelo dataLayer —
       flow_open, flow_step, flow_add_to_cart, checkout_click; quem gere as campanhas liga-os lá ao GA4 e ao TikTok.
       Sem GTM na página ficam no dataLayer sem efeito. Nunca falha o fluxo por causa disto. */
    function track(event, data) {
      try {
        window.dataLayer = window.dataLayer || [];
        var entry = { event: event, flow_type: config.type || '', product_id: config.product.id, product_handle: config.product.handle };
        for (var key in data) if (Object.prototype.hasOwnProperty.call(data, key)) entry[key] = data[key];
        window.dataLayer.push(entry);
      } catch (e) {}
    }

    var $ = function (sel) { return root.querySelector(sel); };
    var $$ = function (sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };
    var dialog = $('[data-flow-dialog]');
    var body = $('[data-flow-body]');
    var foot = $('[data-flow-foot]');
    var next = $('[data-flow-next]');
    var summaryLine = $('[data-flow-summary-line]');
    var steps = config.steps.filter(function (s) { return s !== 'size' || !!$('[data-flow-step="size"]'); }); /* o tamanho de anel (1h-02) só com o passo na página */
    var dual = root.hasAttribute('data-engram-flow-dual'); /* duas fotografias (ecrã 1o-01): duas janelas no mesmo passo */
    var engraving = root.hasAttribute('data-engram-flow-engraving'); /* gravação (ecrã 1f): tipo → palavra · coordenadas · desenho · impressão digital */
    var zone = $('[data-flow-photo-zone]'); /* o painel de upload (fotografia da peça, ou o desenho a gravar); pode não existir */
    var engravingTypes = (config.engraving && config.engraving.types) || [];
    var storeKey = STORE_PREFIX + config.product.id;

    /* comprimento do fio (1g-01): a lista vem da configuração (45 / 55 por defeito nos colares do mapa); o primeiro é o de origem */
    var chainOptions = ((config.size && config.size.options) || []).map(String);
    /* tamanho de anel (1h-02): a opção de variante «Tamanho» não se vê na página — escolhe-se aqui. sizeIndex = a posição dela
       nas opções da variante; a variante final é a cor que veio da página com o tamanho do passo */
    var sizeIndex = steps.indexOf('size') > -1 && config.size && typeof config.size.option === 'number' ? config.size.option : -1;
    /* peça sem fotografia nem gravação (a peça fundadora): o fluxo é só fio, lentes, oferta e extras */
    var plain = steps.indexOf('photo') < 0 && steps.indexOf('memory') < 0;
    var state = {
      step: steps[0],
      size: '', /* sem tamanho à partida: a peça é gravada e não se troca, tem de ser escolhido */
      chain: steps.indexOf('chain') > -1 ? (chainOptions[0] || '') : '',
      variantId: String(config.product.selected_variant_id),
      photo: { status: 'empty', props: [], thumb: '', thumbs: [], done: 0, width: 0, height: 0, name: '' }, /* empty · uploading · ready · error */
      sameTwice: false,
      fineTune: false, /* «afinar o enquadramento» da fotografia, desligado por defeito (pedido do utilizador, 22 Set) */
      /* lentes de Fundador (peça fundadora): quantas (0–2), para que lente é o próximo upload, «enviar depois» e as fotografias */
      lenses: { count: 0, active: 0, slots: [{ props: [], thumb: '' }, { props: [], thumb: '' }] },
      engraving: { type: '', view: 'type', text: '', font: 'script', place: '', coords: '', lat: null, lng: null, date: '', time: '', mapPlace: '', mapLabel: '', mapLat: null, mapLng: null, sky: null, back: false, backText: '' },
      extras: {},   /* variant_id → true */
      message: '',
      adding: false,
      added: null,
      opener: null,
      /* a editar a partir do saco (ecrã 1o-06): { key, keys } — a linha da peça e as linhas a tirar ao guardar */
      edit: null,
      /* as fotografias que vieram do saco, prontas a devolver à app se o cliente cancelar a troca */
      editPhotos: null,
      /* quantos extras do pack já estão no saco (fora esta peça): o desconto da loja conta o saco todo */
      cartBundle: 0,
      /* a devolver as fotografias à app depois de cancelar a troca: mostra-se «a carregar» entretanto */
      restoring: false
    };
    /* com uma só forma de gravar não há escolha: entra-se logo no painel dela */
    if (engraving && engravingTypes.length === 1) { state.engraving.type = engravingTypes[0]; state.engraving.view = 'form'; }

    /* ---------- persistência das escolhas (a fotografia vive na app enquanto a página existir) ---------- */
    function save() {
      /* só o que diz respeito à fotografia fica guardado; oferta e extras recomeçam a cada abertura. A gravação vive só na página:
         depois de um refresh o fluxo volta à escolha do que gravar (pedido do utilizador, 22 Set) */
      try { sessionStorage.setItem(storeKey, JSON.stringify({ fineTune: state.fineTune, sameTwice: state.sameTwice })); } catch (err) {}
    }
    function restore() {
      var saved = null;
      try { saved = JSON.parse(sessionStorage.getItem(storeKey)); } catch (e) { saved = null; }
      if (!saved) return;
      state.fineTune = saved.fineTune === true;
      state.sameTwice = !!saved.sameTwice;
    }
    function forget() { try { sessionStorage.removeItem(storeKey); } catch (e) {} }

    /* ---------- dados da peça ---------- */
    function variant() {
      return config.product.variants.filter(function (v) { return String(v.id) === state.variantId; })[0] || config.product.variants[0];
    }
    /* comprimento do fio: «45 cm», tal como está no cartão (o rótulo vem do locale, não do número) */
    function chainLabel() {
      if (!state.chain) return '';
      var card = $('[data-flow-chain="' + state.chain + '"]');
      return card ? card.getAttribute('data-title') : state.chain;
    }
    /* impressão digital com kit de cera: o n.º de impressões (1 ou 2) é uma opção da variante («Nº de Gravações») que se
       escolhe no painel — não entra na linha da peça («Gold · 2» não diz nada); diz-se à parte, «2 impressões» */
    var countIndex = engraving && typeof config.engraving.count_option === 'number' ? config.engraving.count_option : -1;
    function fpCount() {
      if (countIndex < 0) return 0;
      return parseInt((variant().options || [])[countIndex], 10) === 2 ? 2 : 1;
    }
    function setFpCount(n) {
      var want = (variant().options || []).slice();
      want[countIndex] = String(n);
      var match = config.product.variants.filter(function (v) {
        return v.options && v.options.every(function (o, i) { return String(o) === String(want[i]); });
      })[0];
      if (match) state.variantId = String(match.id);
    }
    /* tamanho de anel: a variante desta cor com um dado tamanho (ou null) */
    function sizeVariant(value) {
      var want = (variant().options || []).slice();
      want[sizeIndex] = value;
      return config.product.variants.filter(function (v) {
        return v.options && v.options.every(function (o, i) { return String(o) === String(want[i]); });
      })[0] || null;
    }
    function sizeAvailable(value) { var v = sizeVariant(value); return !!v && v.available; }
    function setSize(value) {
      var v = sizeVariant(value);
      if (!v || !v.available) return false;
      state.size = String(value);
      state.variantId = String(v.id);
      return true;
    }
    /* a cor pode ter mudado na página desde a última vez: o tamanho já escolhido passa para a cor nova, se ela o tiver */
    function keepSize() {
      if (sizeIndex > -1 && state.size && !setSize(state.size)) state.size = '';
    }
    /* «16 mm», tal como está no chip */
    function sizeLabel() {
      if (sizeIndex < 0 || !state.size) return '';
      var chip = $$('[data-flow-size]').filter(function (el) { return el.getAttribute('data-flow-size') === state.size; })[0];
      return chip ? chip.getAttribute('data-title') : state.size;
    }
    /* as opções da variante tal como se lêem: no kit de cera, «1» passa a «1 impressão»; no anel, o tamanho só depois de escolhido */
    function optionLabels(v) {
      var o = v.options ? v.options.slice() : [v.title];
      if (countIndex > -1) o[countIndex] = strings.fp_count[fpCount()];
      if (sizeIndex > -1) { if (state.size) o[sizeIndex] = sizeLabel(); else o.splice(sizeIndex, 1); }
      return o;
    }
    function renderPmini() {
      $$('[data-flow-pmini-img]').forEach(function (img) { img.src = variant().image || config.product.image; });
      /* peça só com a variante por omissão (ex.: The Lens): sem «Default Title», só o preço */
      $$('[data-flow-pmini-line]').forEach(function (el) { el.textContent = [variantLine(), fmt(variant().price)].filter(Boolean).join(' · '); });
    }
    function variantLine() {
      var v = variant();
      var parts = v.options ? v.options.filter(function (o, i) { return i !== countIndex && i !== sizeIndex; }) : [v.title]; /* o tamanho diz-se à parte, como o fio */
      parts = parts.filter(function (o) { return o && o !== 'Default Title'; });
      if (config.product.material) parts.push(config.product.material);
      return parts.join(' · ');
    }
    function selectedExtras() {
      return config.extras.filter(function (x) { return state.extras[x.variant_id] && x.available; });
    }
    function extrasTotal() {
      return selectedExtras().reduce(function (sum, x) { return sum + x.price; }, 0);
    }
    /* gravação no verso (produto próprio, 3 €): só na palavra e nas coordenadas, quando ligada */
    function backExtra() { return engraving && config.engraving.back_extra && config.engraving.back_extra.available ? config.engraving.back_extra : null; }
    function backAllowed() { return !!backExtra() && /^(text|coordinates|star_map|fingerprint)$/.test(state.engraving.type); } /* impressão digital também leva verso (pedido do utilizador, 28 Set) */
    function backOn() { return backAllowed() && state.engraving.back; }
    function backTotal() { return backOn() ? backExtra().price : 0; }
    /* kit de impressão digital (0 €): vai sempre que a gravação é a impressão digital */
    function kitExtra() { return engraving && state.engraving.type === 'fingerprint' && config.engraving.kit && config.engraving.kit.available ? config.engraving.kit : null; }
    /* pack «4 extras a 50 %»: na loja é o desconto automático «Extras Promo» — 50 % em cada artigo da colecção
       extras-bundle-50 (tag pa:extra:bundle-50) a partir de 4 artigos NO SACO INTEIRO. A Shopify não sabe o que é
       uma peça: não consegue contar quatro extras «desta peça». Por isso o fluxo conta como ela conta — os extras
       do pack que já estão no saco mais os que se escolheram aqui — e só promete desconto quando o saco chega aos
       quatro. Quem desconta é sempre a Shopify; o fluxo limita-se a dizer a mesma conta com antecedência. */
    function bundleExtras() { return config.extras.filter(function (x) { return x.group === 'extras' && x.bundle && x.available; }); }
    function bundleAvailable() { return bundleExtras().length >= 4; }
    function bundlePicked() { return bundleExtras().filter(function (x) { return state.extras[x.variant_id]; }); }
    /* o cartão fica «ligado» quando os quatro estão escolhidos aqui — é o atalho que ele é */
    function bundleAllPicked() { return bundleAvailable() && bundleExtras().every(function (x) { return state.extras[x.variant_id]; }); }
    /* o limiar da loja, contado como ela conta: o saco todo */
    function bundleQualifies() { return bundleAvailable() && (state.cartBundle + bundlePicked().length) >= 4; }
    function half(list) { return list.reduce(function (sum, x) { return sum + Math.round(x.price / 2); }, 0); } /* 50 % linha a linha, como a Shopify */
    function bundleAllSaving() { return half(bundleExtras()); }  /* o que se poupa levando os quatro: é o que o cartão anuncia */
    function bundleSaving() { return bundleQualifies() ? half(bundlePicked()) : 0; } /* o que esta peça poupa de facto */
    function bundleDiscount() { return bundleSaving(); }
    /* carta escrita à mão ligada sem nada escrito: não se avança (como nas outras validações) */
    function messageMissing(group) { return selectedExtras().some(function (x) { return x.message && x.group === group; }) && !state.message.trim(); }
    function total() { return variant().price + extrasTotal() + backTotal() - bundleDiscount(); }
    function fmt(cents) { return money(cents, config.money_format); }
    function photosComplete() { return dual ? (state.photo.done >= 2 || (state.photo.done >= 1 && state.sameTwice)) : state.photo.done >= 1; }
    function photoDone() { return state.photo.status === 'ready' && photosComplete(); }
    function photoLabel(kind) {
      /* kind: summary · review · added — singular ou plural conforme a peça e o que já está guardado */
      if (dual && state.photo.done === 1 && !state.sameTwice && kind === 'summary') return strings.summary_photo1_done;
      if (dual) return strings[kind === 'summary' ? 'summary_photos_done' : kind === 'review' ? 'review_photos_saved' : 'added_photos'];
      return strings[kind === 'summary' ? 'summary_photo_done' : kind === 'review' ? 'review_photo_saved' : 'added_photo'];
    }
    /* o passo da gravação está completo? */
    function memoryDone() {
      var e = state.engraving;
      if (!e.type) return false;
      if (backOn() && !e.backText.trim()) return false;
      if (e.type === 'text') return e.text.trim().length > 0;
      if (e.type === 'morse') return morseText().length > 0; /* pelo menos uma letra ou número que vire conta */
      if (e.type === 'coordinates') return e.place.trim().length > 0;
      if (e.type === 'star_map') return e.date.trim().length > 0 && e.mapPlace.trim().length > 0; /* a hora é opcional: sem ela o céu traça-se às 22:00 (decisão do utilizador, 22 Set) */
      if (e.type === 'artwork') return photoDone();
      return true; /* impressão digital: nada a enviar agora */
    }
    function engravingLabel(kind) {
      /* kind: summary · review · added */
      var e = state.engraving;
      if (!e.type) return '';
      if (kind === 'summary') return fill(strings.summary_type_done, { t: strings.type_short[e.type] });
      if (e.type === 'artwork') {
        if (kind === 'review') return strings.review_engraving_artwork;
        return strings.added_artwork;
      }
      if (kind === 'added') return e.type === 'fingerprint' ? strings.added_fingerprint : (e.type === 'star_map' ? strings.added_map : (e.type === 'morse' ? strings.added_morse : strings.added_engraving));
      if (e.type === 'text') return fill(strings.review_engraving_text, { x: e.text.trim(), f: strings.fonts[e.font] });
      if (e.type === 'morse') return fill(strings.review_engraving_morse, { x: e.text.trim(), c: morseCode() }); /* o texto e o código, as duas linhas que o atelier recebe */
      if (e.type === 'coordinates') return e.coords.trim() ? fill(strings.review_engraving_coordinates_full, { p: e.place.trim(), c: e.coords.trim() }) : fill(strings.review_engraving_coordinates, { p: e.place.trim() });
      if (e.type === 'star_map') return strings.review_engraving_star_map; /* só «Mapa das estrelas»: a miniatura diz o resto (pedido do utilizador) */
      /* kit de cera: «2 impressões · kit incluído» — o número primeiro (pedido do utilizador, 28 Set) */
      if (countIndex > -1) return strings.fp_count_long[fpCount()] + ' · ' + strings.review_engraving_fingerprint; /* «2 impressões digitais» (pedido do utilizador) */
      return strings.review_engraving_fingerprint;
    }
    function personalizationLabel(kind) { return engraving ? engravingLabel(kind) : photoLabel(kind); }
    /* Colar Morse (assets/engram-morse.js): o que o atelier monta, sem acentos («PAI MAE EU»), e o código no formato do tema activo */
    function morseText() { return window.EngramMorse ? window.EngramMorse.normalize(state.engraving.text) : ''; }
    function morseCode() { return window.EngramMorse ? window.EngramMorse.code(state.engraving.text) : ''; }

    /* ---------- UploadKit: o uploader da app dentro do modal ---------- */
    var ukRoot = $('[data-flow-uploadkit]');
    var ukForm = $('[data-flow-uploadkit-form]');
    if (ukForm) ukForm.addEventListener('submit', function (event) { event.preventDefault(); });
    function uploaderEl() { return ukRoot ? ukRoot.querySelector('.uploadkit-uploader') : null; }
    function uploaderConfig() {
      var el = uploaderEl();
      var uk = window.UploadKit;
      if (!el || !uk || !uk.config || !uk.config.uploaders) return null;
      return uk.config.uploaders.filter(function (u) { return u.id === el.getAttribute('data-uploader-id'); })[0] || null;
    }
    function ukAvailable() { return !!(uploaderEl() && window.UploadKit && typeof window.UploadKit.openUploadDialog === 'function' && window.uploadcare); }

    function readUploadkit() {
      if (!ukRoot) return;
      var inputs = Array.prototype.slice.call(ukRoot.querySelectorAll('.uploadkit-attribute-container input[name^="properties["]'));
      var props = inputs.map(function (input) {
        var name = input.getAttribute('name').replace(/^properties\[/, '').replace(/\]$/, '');
        return { name: name, value: input.value };
      });
      /* a miniatura da app traz a sobreposição (moldura) configurada na app, que deixa cantos claros dentro do nosso aro redondo:
         para as janelas do fluxo usa-se a fotografia recortada sem essa camada (o link que vai para o saco fica como a app o escreve) */
      var thumbs = Array.prototype.map.call(ukRoot.querySelectorAll('.uploadkit-thumbnail'), function (img) {
        return (img.getAttribute('src') || '').replace(/-\/overlay\/[^\/]+\/[^\/]+\/[^\/]+\//, '');
      });
      var uploader = uploaderConfig();
      var doneFiles = uploader && uploader.files ? uploader.files.filter(function (f) { return f.fileInfo; }) : [];
      var info = doneFiles[0] && doneFiles[0].fileInfo;
      /* nitidez: por fotografia (recorte, senão original); a mais pequena decide o aviso geral */
      var size = null;
      state.photo.sizes = doneFiles.map(function (f) {
        var s = f.fileInfo.crop && f.fileInfo.crop.width ? f.fileInfo.crop : f.fileInfo.originalImageInfo;
        if (s && (!size || Math.min(s.width, s.height) < Math.min(size.width, size.height))) size = s;
        return s ? { width: s.width, height: s.height } : null;
      });
      /* A editar a partir do saco: a fotografia veio da linha do carrinho, mas a app está vazia — ela nunca
         chegou a receber nada nesta página. Quando acaba de carregar chama isto, e sem esta guarda apagava
         o que se semeou. Enquanto o cliente não enviar outra, a fotografia é a que já estava na peça. */
      if (!props.length && state.edit && (state.photo.status === 'ready' || state.restoring)) { renderPhoto(); renderFoot(); renderCard(); return; }
      if (props.length) state.restoring = false;
      state.photo.props = props;
      state.photo.thumbs = thumbs;
      state.photo.thumb = thumbs[0] || '';
      state.photo.done = doneFiles.length;
      state.photo.width = size ? size.width : 0;
      state.photo.height = size ? size.height : 0;
      if (dual && state.photo.done >= 2) state.sameTwice = false;
      state.photo.direct = (props.filter(function (p) { return /direct link/i.test(p.name); })[0] || {}).value || (props[0] || {}).value || '';
      state.photo.name = info ? info.name : state.photo.name;

      var pending = uploader && uploader.files ? uploader.files.filter(function (f) { return !f.fileInfo; }) : [];
      if (pending.length) { watchUpload(pending[0]); if (state.photo.status !== 'uploading') setPhotoStatus('uploading'); }
      else if (props.length) setPhotoStatus('ready');
      else if (state.photo.status !== 'error') setPhotoStatus('empty');
      renderPhoto();
      renderFoot();
      renderProgress(); /* com duas fotografias o trilho avança para «foto 2» assim que a primeira fica guardada */
      /* as opções do cartão SÃO as fotografias da peça: se elas mudam, aquilo tem de se redesenhar.
         Sem isto, a editar (onde as fotografias chegam depois do passo já estar desenhado) o cartão
         ficava sem nenhuma para escolher. */
      renderCard();
      save();
    }

    function watchUpload(file) {
      if (!file || !file.ucObject || file.__engramWatched) return;
      file.__engramWatched = true;
      state.photo.name = '';
      try {
        file.ucObject.progress(function (info) {
          var name = info && info.incompleteFileInfo && info.incompleteFileInfo.name;
          if (name) state.photo.name = name;
          var percent = Math.round((info && info.progress ? info.progress : 0) * 100);
          var bar = $('[data-flow-uploading-bar]');
          if (bar) bar.style.width = percent + '%';
          var label = $('[data-flow-uploading-percent]');
          if (label) label.textContent = fill(strings.percent, { n: percent });
          var nameEl = $('[data-flow-uploading-name]');
          if (nameEl) nameEl.textContent = state.photo.name ? fill(strings.uploading, { f: state.photo.name }) : strings.uploading_generic;
        });
        file.ucObject.fail(function (error, info) {
          var name = (info && info.name) || state.photo.name;
          showPhotoError(name ? fill(strings.error_file, { f: name }) : strings.error);
          resetUploader(false);
        });
      } catch (e) {}
    }

    function resetUploader(keepStatus) {
      var uploader = uploaderConfig();
      if (uploader && window.UploadKit && typeof window.UploadKit.refreshUploader === 'function') {
        uploader.fileObject = null;
        uploader.files = [];
        try { window.UploadKit.refreshUploader(uploader); } catch (e) {}
      }
      state.photo.props = [];
      state.photo.thumb = '';
      state.photo.thumbs = [];
      state.photo.done = 0;
      if (!keepStatus) return;
      setPhotoStatus('empty');
      renderPhoto();
      renderFoot();
    }

    /* a app UploadKit carrega o seu script depois da página: se o cliente clicar antes de ela estar pronta, espera-se até 8 s
       antes de dar o erro (QA do Fábio, 29 Out: «uploads unavailable» aparecia às vezes no desenho) */
    var ukWaiting = false;
    function openDialog(fresh) {
      if (!ukAvailable()) {
        if (ukWaiting) return;
        ukWaiting = true;
        var started = Date.now();
        (function poll() {
          /* o cliente fechou o fluxo entretanto: não abrir a janela nem mostrar o erro por cima da página */
          if (!root.classList.contains('is-open')) { ukWaiting = false; return; }
          if (ukAvailable()) { ukWaiting = false; openDialog(fresh); return; }
          if (Date.now() - started > 8000) { ukWaiting = false; showPhotoError(strings.unavailable); return; }
          setTimeout(poll, 250);
        })();
        return;
      }
      if (fresh) resetUploader(false);
      hidePhotoError();
      /* A editar: «Trocar fotografia» limpa a app antes de abrir o diálogo. Se o cliente fechar sem escolher
         nada, ficava sem as que já tinha — e a peça no saco ainda as tem. Repõem-se. */
      if (fresh && state.edit) restoreOnCancel();
      try { window.UploadKit.openUploadDialog.call(uploaderEl()); }
      catch (e) { showPhotoError(strings.unavailable); }
    }

    function restoreOnCancel() {
      var seed = state.editPhotos;
      if (!seed || !seed.length) return;
      var opened = false;
      /* de 100 em 100ms: fechar o diálogo e ver a fotografia voltar tem de parecer a mesma coisa */
      var timer = setInterval(function () {
        if (document.querySelector('.uploadcare--dialog')) { opened = true; return; }
        if (!opened) return;
        clearInterval(timer);
        var uploader = uploaderConfig();
        if (uploader && uploader.files && uploader.files.length) return; /* escolheu outras: fica o que escolheu */
        /* a app leva o seu tempo a ir buscar o ficheiro outra vez: diz-se que está a carregar em vez de
           deixar o ecrã a fingir que está tudo bem */
        state.restoring = true;
        setPhotoStatus('uploading');
        renderPhoto();
        renderFoot();
        seedUploadkit(seed);
      }, 100);
      setTimeout(function () { clearInterval(timer); }, 180000);
    }

    /* ---------- Fotografia para o cartão (lógica do tema activo): a da peça ou outra, do uploader «Fotografia do cartão» ---------- */
    var cardPanel = $('[data-flow-photocard]');
    var cardRoot = $('[data-flow-photocard-uploadkit]');
    var cardForm = $('[data-flow-photocard-form]');
    if (cardForm) cardForm.addEventListener('submit', function (event) { event.preventDefault(); });
    state.card = { source: '', index: 0, props: [], thumb: '' }; /* source: piece · new */
    function cardUploaderEl() { return cardRoot ? cardRoot.querySelector('.uploadkit-uploader') : null; }
    function withoutOverlay(url) { return String(url || '').replace(/-\/overlay\/[^\/]+\/[^\/]+\/[^\/]+\//g, ''); }
    function cardExtra() { return config.extras.filter(function (x) { return x.photo; })[0]; }
    function cardOn() { var x = cardExtra(); return !!(x && state.extras[x.variant_id]); }
    function piecePhotos() {
      /* as fotografias da peça, tal como a app as escreveu: propriedade visível + link directo, com a miniatura */
      var visible = state.photo.props.filter(function (p) { return p.name.charAt(0) !== '_'; });
      return visible.map(function (p, i) {
        var direct = state.photo.props.filter(function (d) { return d.name === '_' + p.name + ' (direct link)'; })[0];
        return { value: p.value, direct: direct ? direct.value : '', thumb: state.photo.thumbs[i] || '' };
      });
    }
    function readCardUploadkit() {
      if (!cardRoot) return;
      var inputs = Array.prototype.slice.call(cardRoot.querySelectorAll('.uploadkit-attribute-container input[name^="properties["]'));
      /* mesma guarda da fotografia da peça: a editar, o cartão já traz a sua e a app está vazia */
      if (!inputs.length && state.edit && state.card.source === 'new') { renderCard(); renderFoot(); return; }
      state.card.props = inputs.map(function (input) { return { name: input.getAttribute('name').replace(/^properties\[/, '').replace(/\]$/, ''), value: input.value }; });
      var thumb = cardRoot.querySelector('.uploadkit-thumbnail');
      state.card.thumb = thumb ? (thumb.getAttribute('src') || '').replace(/-\/overlay\/[^\/]+\/[^\/]+\/[^\/]+\//, '') : '';
      if (state.card.props.length) state.card.source = 'new';
      renderCard();
      renderFoot();
    }
    function cardChosen() {
      /* o que vai para a linha do cartão: {value, direct, label} ou null */
      if (!cardOn()) return null;
      if (state.card.source === 'new') {
        var visible = state.card.props.filter(function (p) { return p.name.charAt(0) !== '_'; })[0];
        var direct = state.card.props.filter(function (p) { return p.name.charAt(0) === '_' && /direct link/i.test(p.name); })[0];
        return visible ? { value: visible.value, direct: direct ? direct.value : '', label: strings.photocard_new_label, thumb: state.card.thumb } : null;
      }
      var photos = piecePhotos();
      var chosen = photos[state.card.index] || photos[0];
      if (!chosen) return null;
      var options = $('[data-flow-photocard-options]');
      var label = photos.length > 1 ? fill(options.getAttribute('data-label-slot'), { n: (photos[state.card.index] ? state.card.index : 0) + 1 }) : options.getAttribute('data-label-piece');
      /* a mesma fotografia, mas quadrada: os links da peça levam a moldura redonda da app (-/overlay/…); no cartão essa camada sai
         e fica só o recorte 1:1 — é o que o atelier recebe na linha do cartão */
      return { value: withoutOverlay(chosen.value), direct: withoutOverlay(chosen.direct), label: label, thumb: chosen.thumb };
    }
    function cardComplete() { return !cardOn() || !!cardChosen(); }
    function renderCard() {
      if (!cardPanel) return;
      var x = cardExtra();
      var wrap = x ? $('[data-flow-extra="' + x.variant_id + '"]') : null;
      if (!wrap) { cardPanel.hidden = true; return; }
      if (cardPanel.parentNode !== wrap) wrap.appendChild(cardPanel);
      cardPanel.hidden = !cardOn();
      wrap.classList.add('has-message');
      if (cardPanel.hidden) return;

      var photos = piecePhotos();
      if (state.card.source !== 'new' && photos.length) state.card.source = 'piece';
      if (state.card.source !== 'new' && !photos.length) state.card.source = '';
      var options = $('[data-flow-photocard-options]');
      options.textContent = '';
      photos.forEach(function (photo, i) {
        var option = document.createElement('button');
        option.type = 'button';
        option.className = 'engram-flow__photocard-option';
        option.setAttribute('role', 'radio');
        option.setAttribute('data-flow-photocard-pick', i);
        option.setAttribute('aria-checked', state.card.source === 'piece' && (state.card.index === i || (!photos[state.card.index] && i === 0)) ? 'true' : 'false');
        var thumb = document.createElement('span');
        thumb.className = 'engram-flow__photocard-thumb';
        if (photo.thumb) { var img = document.createElement('img'); img.src = photo.thumb; img.alt = ''; img.width = 48; img.height = 48; thumb.appendChild(img); }
        var copy = document.createElement('span');
        copy.className = 'engram-flow__photocard-copy';
        var title = document.createElement('b');
        title.textContent = photos.length > 1 ? fill(options.getAttribute('data-label-slot'), { n: i + 1 }) : options.getAttribute('data-label-piece');
        copy.appendChild(title);
        option.appendChild(thumb); option.appendChild(copy);
        options.appendChild(option);
      });
      $('[data-flow-photocard-empty]').hidden = photos.length > 0 || state.card.source === 'new';
      var isNew = state.card.source === 'new';
      $('[data-flow-photocard-new]').setAttribute('aria-checked', isNew ? 'true' : 'false');
      /* a «outra fotografia», depois de carregada, fica visível na opção mesmo quando se volta a escolher a da peça */
      var newImg = $('[data-flow-photocard-new-img]');
      newImg.hidden = !state.card.thumb;
      if (!newImg.hidden) newImg.src = state.card.thumb;
      $('[data-flow-photocard-new-thumb]').classList.toggle('engram-flow__photocard-thumb--empty', newImg.hidden);
      var newText = $('[data-flow-photocard-new-text]');
      newText.textContent = newText.getAttribute(state.card.props.length ? 'data-done' : 'data-empty');
      $('[data-flow-photocard-replace]').hidden = !state.card.props.length;
    }
    function resetCardUploader() {
      var el = cardUploaderEl();
      var uk = window.UploadKit;
      if (!el || !uk || !uk.config || !uk.config.uploaders) return;
      var u = uk.config.uploaders.filter(function (c) { return c.id === el.getAttribute('data-uploader-id'); })[0];
      if (!u) return;
      u.fileObject = null; u.files = [];
      try { uk.refreshUploader(u); } catch (e) {}
    }
    function openCardDialog() {
      var el = cardUploaderEl();
      var error = $('[data-flow-photocard-error]');
      if (!el || !window.UploadKit || typeof window.UploadKit.openUploadDialog !== 'function' || !window.uploadcare) { if (error) error.hidden = false; return; }
      if (error) error.hidden = true;
      try { window.UploadKit.openUploadDialog.call(el); } catch (e) { if (error) error.hidden = false; }
    }

    /* ---------- lentes de Fundador (peça fundadora; docs/MEMORY_CLUB.md §6) ----------
       Nenhuma, uma ou duas lentes para dentro da The Key. Cada fotografia carrega-se pelo uploader da própria The Lens
       (um <div class="uploadkit"> com o JSON dela, como o cartão com fotografia), uma de cada vez: state.lenses.active
       diz para que lente é. Guarda-se aqui tal como a app a escreveu e a app fica vazia para a seguinte. No saco entra
       uma linha «The Lens» por lente, ligada à peça (linked); o desconto «The Memory Club · Fundadores» (a Key e até 2 lentes com a peça fundadora) põe-nas a 0 €. */
    var lensRoot = $('[data-flow-lens-uploadkit]');
    var lensForm = $('[data-flow-lens-form]');
    if (lensForm) lensForm.addEventListener('submit', function (event) { event.preventDefault(); });
    function lensUploaderEl() { return lensRoot ? lensRoot.querySelector('.uploadkit-uploader') : null; }
    function lensOn() { return steps.indexOf('lenses') > -1 && !!config.lens; }
    function lensCount() { return lensOn() ? state.lenses.count : 0; }
    function lensReady(i) { return state.lenses.slots[i].props.length > 0; }
    function lensesDone() { for (var i = 0; i < lensCount(); i++) { if (!lensReady(i)) return false; } return true; }
    function lensLabel() { var n = lensCount(); return n === 1 ? strings.lens_one : fill(strings.lens_other, { n: n }); }
    var lensResetting = false;
    function resetLensUploader() {
      var el = lensUploaderEl();
      var uk = window.UploadKit;
      if (!el || !uk || !uk.config || !uk.config.uploaders) return;
      var u = uk.config.uploaders.filter(function (c) { return c.id === el.getAttribute('data-uploader-id'); })[0];
      if (!u) return;
      lensResetting = true;
      u.fileObject = null; u.files = [];
      try { uk.refreshUploader(u); } catch (e) {}
      lensResetting = false;
    }
    function readLensUploadkit() {
      if (!lensRoot || lensResetting) return;
      var inputs = Array.prototype.slice.call(lensRoot.querySelectorAll('.uploadkit-attribute-container input[name^="properties["]'));
      if (!inputs.length) return;
      var thumb = lensRoot.querySelector('.uploadkit-thumbnail');
      state.lenses.slots[state.lenses.active] = {
        props: inputs.map(function (input) { return { name: input.getAttribute('name').replace(/^properties\[/, '').replace(/\]$/, ''), value: input.value }; }),
        thumb: thumb ? (thumb.getAttribute('src') || '') : ''
      };
      /* a app fica vazia para a lente seguinte: esta fotografia já está guardada aqui */
      setTimeout(resetLensUploader, 0);
      renderLenses(); renderFoot();
    }
    function openLensDialog(i) {
      state.lenses.active = i;
      var el = lensUploaderEl();
      var error = $('[data-flow-lens-error]');
      if (!el || !window.UploadKit || typeof window.UploadKit.openUploadDialog !== 'function' || !window.uploadcare) { if (error) error.hidden = false; return; }
      if (error) error.hidden = true;
      resetLensUploader();
      try { window.UploadKit.openUploadDialog.call(el); } catch (e) { if (error) error.hidden = false; }
    }
    function renderLenses() {
      if (!lensOn()) return;
      var count = state.lenses.count;
      $$('[data-flow-lens-count]').forEach(function (b) { b.setAttribute('aria-checked', b.getAttribute('data-flow-lens-count') === String(count) ? 'true' : 'false'); });
      $('[data-flow-lens-none]').hidden = count > 0;
      $('[data-flow-lens-slots]').hidden = count === 0;
      $$('[data-flow-lens-slot]').forEach(function (slot) {
        var i = parseInt(slot.getAttribute('data-flow-lens-slot'), 10);
        var data = state.lenses.slots[i];
        slot.hidden = i >= count;
        var box = slot.querySelector('[data-flow-lens-thumb]');
        var img = box.querySelector('img');
        img.hidden = !data.thumb;
        if (data.thumb) img.src = data.thumb;
        box.classList.toggle('engram-flow__photocard-thumb--empty', !data.thumb);
        var status = slot.querySelector('[data-flow-lens-status]');
        status.textContent = status.getAttribute(data.props.length ? 'data-done' : 'data-empty');
        var choose = slot.querySelector('[data-flow-lens-choose]');
        choose.textContent = choose.getAttribute(data.props.length ? 'data-replace' : 'data-choose');
      });
    }
    /* as linhas «The Lens» para o saco: a fotografia tal como a app a escreveu */
    function lensItems(linked) {
      var items = [];
      for (var i = 0; i < lensCount(); i++) {
        var item = linked(config.lens);
        var data = state.lenses.slots[i];
        data.props.forEach(function (prop) { item.properties[prop.name] = prop.value; });
        items.push(item);
      }
      return items;
    }

    var hooked = false;
    function hookUploadkit() {
      var uk = window.UploadKit;
      if (!uk || hooked) return;
      hooked = true;
      uk.callbacks = uk.callbacks || {};
      var previous = { afterRefresh: uk.callbacks.afterRefresh, dialogDone: uk.callbacks.dialogDone };
      uk.callbacks.afterRefresh = function (data) {
        if (previous.afterRefresh) previous.afterRefresh(data);
        if (data && data.el && ukRoot && ukRoot.contains(data.el)) readUploadkit();
        if (data && data.el && cardRoot && cardRoot.contains(data.el)) readCardUploadkit();
        if (data && data.el && lensRoot && lensRoot.contains(data.el)) readLensUploadkit();
      };
      uk.callbacks.dialogDone = function (data) {
        if (previous.dialogDone) previous.dialogDone(data);
        readUploadkit();
        readCardUploadkit();
        readLensUploadkit();
      };
      /* rede de segurança: a app escreve os inputs no container; qualquer mudança lá dentro actualiza o estado */
      if (ukRoot) new MutationObserver(function () { readUploadkit(); }).observe(ukRoot, { childList: true, subtree: true });
      if (cardRoot) new MutationObserver(function () { readCardUploadkit(); }).observe(cardRoot, { childList: true, subtree: true });
      if (lensRoot) new MutationObserver(function () { readLensUploadkit(); }).observe(lensRoot, { childList: true, subtree: true });
    }
    document.addEventListener('uploadkit:initialized', hookUploadkit);
    if (window.UploadKit && window.UploadKit.initialized) hookUploadkit();

    /* ---------- estado da fotografia ---------- */
    function setPhotoStatus(status) {
      state.photo.status = status;
    }
    function showPhotoError(text) {
      setPhotoStatus('error');
      var box = $('[data-flow-photo-error]');
      if (!box) return;
      $('[data-flow-photo-error-text]').textContent = text;
      box.hidden = false;
      renderPhoto();
      renderFoot();
    }
    function hidePhotoError() {
      var box = $('[data-flow-photo-error]');
      if (box) box.hidden = true;
      if (state.photo.status === 'error') setPhotoStatus('empty');
    }

    function renderPhoto() {
      var step = zone;
      if (!step) return;
      var status = state.photo.status;
      var hasPhoto = status === 'ready';          /* já há pelo menos uma fotografia guardada */
      var isReady = hasPhoto && photosComplete();                       /* o passo está completo */
      step.classList.toggle('is-ready', isReady && !dual);
      step.classList.toggle('is-dual-ready', isReady && dual); /* desktop: as duas janelas empilhadas à esquerda, como o aro do 1j */
      $('[data-flow-photo-preview]').hidden = !isReady || dual;
      $('[data-flow-photo-ready]').hidden = !isReady;
      $('[data-flow-photo-uploading]').hidden = status !== 'uploading';
      /* com duas fotografias a zona de escolha fica sempre (engloba as janelas); guardadas as duas, perde o tracejado e o texto */
      var choose = $('[data-flow-photo-choose]');
      choose.hidden = dual ? status === 'uploading' : (isReady || status === 'uploading');
      choose.classList.toggle('is-ready', dual && isReady);
      $('[data-flow-photo-choose-label]').hidden = dual && isReady;
      $('[data-flow-photo-choose-caption]').hidden = dual && isReady;
      if (dual) $('[data-flow-duo-ready-caption]').hidden = !isReady;
      /* a peça, o título e o texto ficam sempre no topo, também com a fotografia/desenho guardado (pedido do utilizador, 25 Set) */
      $('[data-flow-photo-tips]').hidden = hasPhoto;
      $('[data-flow-photo-private]').hidden = hasPhoto;
      if (status !== 'error') $('[data-flow-photo-error]').hidden = true;

      var chooseLabel = $('[data-flow-photo-choose-label]');
      var chooseKey = status === 'error' ? 'data-label-again' : 'data-label';
      if (dual) chooseKey = state.photo.done >= 1 ? 'data-label-second' : (status === 'error' ? 'data-label-again' : 'data-label-both');
      chooseLabel.textContent = chooseLabel.getAttribute(chooseKey);

      if (dual) {
        /* as duas janelas: guardada (aro areia + miniatura) ou por escolher (tracejado +) */
        $$('[data-flow-duo-slot]').forEach(function (slot, i) {
          var src = state.photo.thumbs[i] || (state.sameTwice ? state.photo.thumbs[0] : '');
          var filled = !!src;
          slot.classList.toggle('is-filled', filled);
          slot.querySelector('[data-flow-duo-ring]').hidden = !filled;
          slot.querySelector('[data-flow-duo-empty]').hidden = filled;
          var img = slot.querySelector('[data-flow-duo-img]');
          if (filled && img.getAttribute('src') !== src) img.src = src;
          /* a legenda («Foto 1») só aparece com a fotografia lá; vazia, chega o «+» */
          slot.querySelector('.engram-flow__duo-caption').hidden = !filled;
        });
        var sameBox = $('[data-flow-same-twice-box]');
        sameBox.hidden = !(hasPhoto && state.photo.done === 1);
        var sameTog = $('[data-flow-same-twice]');
        sameTog.setAttribute('aria-checked', state.sameTwice ? 'true' : 'false');
        sameBox.classList.toggle('is-on', state.sameTwice);
      }

      if (isReady) {
        var img = $('[data-flow-photo-img]');
        if (state.photo.thumb && img.getAttribute('src') !== state.photo.thumb) img.src = state.photo.thumb;
        var side = Math.min(state.photo.width || 0, state.photo.height || 0);
        var known = side > 0;
        $('[data-flow-photo-sharp]').hidden = !known || side < 600;
        var soft = $('[data-flow-photo-soft]');
        soft.hidden = !known || side >= 600;
        if (known && side < 600) {
          var softText = fill($('[data-flow-photo-soft-text]').getAttribute('data-template'), { s: state.photo.width + ' × ' + state.photo.height });
          if (dual && !state.sameTwice) {
            /* com duas fotografias diz-se qual delas: «Foto 1», «Foto 2» ou as duas */
            var softOnes = [];
            (state.photo.sizes || []).forEach(function (s, i) { if (s && Math.min(s.width, s.height) < 600) softOnes.push({ n: i + 1, s: s.width + ' × ' + s.height }); });
            if (softOnes.length === 1) softText = fill(strings.soft_one, softOnes[0]);
            else if (softOnes.length > 1) softText = fill(strings.soft_both, { s: softOnes.map(function (o) { return o.s; }).join(' ' + strings.list_and + ' ') });
          }
          $('[data-flow-photo-soft-text]').textContent = softText;
        }
      }
      var tog = $('[data-flow-fine-tune]'); /* só na fotografia; no desenho a imagem é ajustada à medalha sem escolha */
      if (tog) {
        tog.setAttribute('aria-checked', state.fineTune ? 'true' : 'false');
        tog.closest('[data-flow-opt]').classList.toggle('is-on', state.fineTune);
      }
    }

    /* ---------- coordenadas (1f-03): o lugar procura-se no mapa (Nominatim) e o ponto ajusta-se (Leaflet), como no tema activo ---------- */
    var mapEl = $('[data-flow-coords-map]');
    var map = null, marker = null;
    function formatCoordinate(value, isLat) {
      var n = Number(value);
      if (!isFinite(n)) return '';
      return Math.abs(n).toFixed(4) + '° ' + (isLat ? (n >= 0 ? 'N' : 'S') : (n >= 0 ? 'E' : 'W'));
    }
    function setCoordsStatus(text, isError) {
      /* aviso areia quando algo falhou; nota azul («ponto movido») quando é só informação */
      var box = $('[data-flow-coords-status]');
      if (!box) return;
      box.hidden = !text;
      box.classList.toggle('engram-notice--warning', !!isError);
      box.classList.toggle('engram-notice--info', !isError);
      var mark = box.querySelector('[data-flow-coords-mark]');
      if (mark) { mark.className = isError ? 'engram-flow__warn-mark' : 'engram-flow__tick'; mark.textContent = isError ? '!' : '✓'; }
      $('[data-flow-coords-status-text]').textContent = text || '';
    }
    function setPoint(lat, lng, moved) {
      /* guarda o ponto, escreve as coordenadas como vão para a placa e põe (ou move) o mapa */
      state.engraving.lat = Number(lat); state.engraving.lng = Number(lng);
      state.engraving.coords = formatCoordinate(lat, true) + ', ' + formatCoordinate(lng, false);
      setCoordsStatus(moved ? strings.coords_adjusted : '', false);
      showMap();
      renderEngraving(); renderFoot(); save();
    }
    function showMap() {
      var e = state.engraving;
      if (!mapEl || !window.L || e.lat === null || e.lng === null) return;
      mapEl.hidden = false;
      var hint = $('[data-flow-coords-map-hint]');
      if (hint) hint.hidden = false;
      if (!map) {
        map = window.L.map(mapEl, { scrollWheelZoom: false, attributionControl: true }).setView([e.lat, e.lng], 13);
        window.L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', { maxZoom: 19, attribution: '&copy; OpenStreetMap' }).addTo(map);
        map.attributionControl.setPrefix(''); /* sem o prefixo do Leaflet (traz uma bandeira em emoji); fica só o crédito obrigatório do OpenStreetMap */
        /* o ponto é um círculo em tinta (sem imagem de pino), arrastável; tocar no mapa também o move */
        var icon = window.L.divIcon({ className: 'engram-flow__pin-wrap', html: '<span class="engram-flow__pin"></span>', iconSize: [22, 22], iconAnchor: [11, 11] });
        marker = window.L.marker([e.lat, e.lng], { draggable: true, icon: icon, keyboard: false }).addTo(map);
        marker.on('dragend', function () { var p = marker.getLatLng(); setPoint(p.lat, p.lng, true); });
        map.on('click', function (event) { marker.setLatLng(event.latlng); setPoint(event.latlng.lat, event.latlng.lng, true); });
      } else {
        map.setView([e.lat, e.lng], Math.max(map.getZoom(), 13));
        marker.setLatLng([e.lat, e.lng]);
      }
      setTimeout(function () { if (map) map.invalidateSize(); }, 150);
    }
    /* procurador de lugares: à medida que se escreve (≥ 3 letras, 350 ms de pausa) pede até 5 sugestões ao Nominatim e mostra-as
       por baixo do campo; escolhe-se com o toque ou com as setas + Enter. O mesmo nas coordenadas e no mapa das estrelas. */
    function placeLabel(hit) {
      /* «Porto, Porto, Área Metropolitana do Porto, Portugal» → «Porto, Portugal» (primeira parte + país) */
      var parts = String(hit.display_name || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
      if (!parts.length) return '';
      var last = parts[parts.length - 1];
      return parts[0] === last ? parts[0] : parts[0] + ', ' + last;
    }
    function placeRest(hit) {
      var parts = String(hit.display_name || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
      return parts.slice(1, -1).slice(0, 3).join(', ');
    }
    function makeFinder(input, onPick) {
      var wrap = input.closest('[data-flow-finder]');
      var list = wrap.querySelector('[data-flow-suggest]');
      var group = wrap.parentElement;
      var status = group.querySelector('[data-flow-finder-status]');
      var statusText = group.querySelector('[data-flow-finder-status-text]');
      var picked = group.querySelector('[data-flow-finder-picked]');
      var pickedText = group.querySelector('[data-flow-finder-picked-text]');
      var hint = group.querySelector('[data-flow-finder-hint]');
      var timer = null, controller = null, requestId = 0, hits = [], active = -1;
      /* Lugar escrito e não escolhido: sem sugestão não há coordenadas, e sem elas o céu não se traça e as coordenadas
         ficam «a confirmar». Por isso, ao sair do campo sem escolher, fica a primeira sugestão — com a linha «Porto,
         Portugal · 41,15° N…» à vista, para se ver o que ficou e trocar se não for esse (pedido do utilizador, 28 Set).
         «resolve» faz o mesmo sem o campo ter sido tocado: a editar do saco, uma linha sem coordenadas. */
      var chosen = false, auto = false;
      function say(text) { if (!status) return; status.hidden = !text; statusText.textContent = text || ''; }
      function close() { list.hidden = true; list.textContent = ''; hits = []; active = -1; input.setAttribute('aria-expanded', 'false'); input.removeAttribute('aria-activedescendant'); }
      function mark(text) { if (!picked) return; picked.hidden = !text; pickedText.textContent = text || ''; if (hint) hint.hidden = !!text; }
      function render() {
        list.textContent = '';
        hits.forEach(function (hit, i) {
          var li = document.createElement('li');
          li.className = 'engram-flow__suggest-item';
          li.id = list.id + '-' + i;
          li.setAttribute('role', 'option');
          li.setAttribute('aria-selected', i === active ? 'true' : 'false');
          li.setAttribute('data-flow-suggest-pick', i);
          var b = document.createElement('b'); b.textContent = placeLabel(hit);
          var small = document.createElement('small'); small.textContent = placeRest(hit);
          li.appendChild(b); if (small.textContent) li.appendChild(small);
          list.appendChild(li);
        });
        list.hidden = !hits.length;
        input.setAttribute('aria-expanded', hits.length ? 'true' : 'false');
        if (active > -1) input.setAttribute('aria-activedescendant', list.id + '-' + active); else input.removeAttribute('aria-activedescendant');
      }
      function pick(i) {
        var hit = hits[i];
        if (!hit) return;
        var label = placeLabel(hit);
        input.value = label;
        chosen = true; auto = false;
        close();
        say('');
        mark(fill(strings.picked, { p: label, c: formatCoordinate(hit.lat, true) + ', ' + formatCoordinate(hit.lon, false) }));
        onPick({ lat: Number(hit.lat), lng: Number(hit.lon), label: label, full: String(hit.display_name || '') });
      }
      function search(query) {
        if (controller) { try { controller.abort(); } catch (e) {} }
        controller = null;
        var id = ++requestId;
        var options = { headers: { Accept: 'application/json' } };
        if (typeof AbortController === 'function') { controller = new AbortController(); options.signal = controller.signal; }
        var lang = config.locale ? '&accept-language=' + encodeURIComponent(config.locale) : '';
        fetch('https://nominatim.openstreetmap.org/search?format=json&limit=5&dedupe=1' + lang + '&q=' + encodeURIComponent(query), options)
          .then(function (response) { if (!response.ok) throw new Error('search'); return response.json(); })
          .then(function (results) {
            if (id !== requestId) return;
            /* sem repetidos: cidade e distrito com o mesmo nome («Porto, Portugal» duas vezes) — fica o primeiro */
            var seen = {};
            hits = (Array.isArray(results) ? results : []).filter(function (hit) { var key = placeLabel(hit) + '|' + placeRest(hit); if (seen[key]) return false; seen[key] = true; return true; });
            active = hits.length ? 0 : -1;
            /* já saiu do campo (ou é a edição): fica a primeira, sem abrir a lista */
            if (hits.length && !chosen && (auto || document.activeElement !== input)) { pick(0); return; }
            auto = false;
            render();
            say(hits.length ? '' : strings.coords_not_found);
          })
          .catch(function (error) {
            if (id !== requestId || (error && error.name === 'AbortError')) return;
            close();
            say(strings.coords_failed);
          });
      }
      input.addEventListener('input', function () {
        chosen = false; auto = false;
        mark('');
        say('');
        clearTimeout(timer);
        var query = input.value.trim();
        if (query.length < 3) { close(); return; }
        timer = setTimeout(function () { search(query); }, 350);
      });
      input.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          if (!hits.length) return;
          event.preventDefault();
          active = (active + (event.key === 'ArrowDown' ? 1 : hits.length - 1)) % hits.length;
          render();
          return;
        }
        if (event.key === 'Enter') {
          event.preventDefault();
          if (hits.length) pick(active > -1 ? active : 0);
          else if (input.value.trim().length >= 3) { clearTimeout(timer); search(input.value.trim()); }
          return;
        }
        if (event.key === 'Escape' && !list.hidden) { event.preventDefault(); event.stopPropagation(); close(); }
      });
      list.addEventListener('mousedown', function (event) { event.preventDefault(); }); /* o campo não perde o foco ao tocar na lista */
      list.addEventListener('click', function (event) {
        var item = event.target.closest('[data-flow-suggest-pick]');
        if (item) pick(parseInt(item.getAttribute('data-flow-suggest-pick'), 10));
      });
      input.addEventListener('blur', function () {
        setTimeout(function () {
          if (document.activeElement === input) return;
          if (!chosen && hits.length) pick(active > -1 ? active : 0); else close();
        }, 150);
      });
      function resolve(query) {
        query = String(query || '').trim();
        if (chosen || query.length < 3) return;
        auto = true;
        search(query);
      }
      return { mark: mark, close: close, resolve: resolve };
    }
    var placeFinder = $('[data-flow-place-input]') ? makeFinder($('[data-flow-place-input]'), function (hit) {
      state.engraving.place = hit.label;
      setPoint(hit.lat, hit.lng, false);
    }) : null;
    var mapFinder = $('[data-flow-map-place-input]') ? makeFinder($('[data-flow-map-place-input]'), function (hit) {
      state.engraving.mapPlace = hit.label; state.engraving.mapLabel = hit.label;
      state.engraving.mapLat = hit.lat; state.engraving.mapLng = hit.lng;
      state.engraving.sky = null; /* o céu já gerado deixa de valer: o lugar mudou */
      renderEngraving(); renderFoot(); save();
    }) : null;

    /* ---------- mapa das estrelas (1g-02): lugar por pesquisa; o céu vem do TeeInBlue (SDK da app), como no tema activo ---------- */
    var skyBusy = false;
    function dateLabel(iso) {
      /* «2019-08-14» (campo de data) → «14/08/2019», como o atelier lê */
      var m = String(iso || '').match(/^(\d{4})-(\d{2})-(\d{2})$/);
      return m ? m[3] + '/' + m[2] + '/' + m[1] : String(iso || '');
    }
    function tibReady() {
      return !!(window.teeinblue && typeof window.teeinblue.createCustomization === 'function' && window.teeinblueCampaign && window.teeinblueCampaign.isTeeInBlueProduct && window.teeinblueCampaign.productId);
    }
    function skyTime() { return state.engraving.time.trim() || (config.engraving.default_time || '22:00'); } /* sem hora, o céu das 22:00 */
    function skyInputs() {
      var e = state.engraving;
      return e.mapLat !== null && e.mapLng !== null && e.date.trim() ? JSON.stringify([e.mapLat, e.mapLng, e.date, skyTime(), state.variantId]) : '';
    }
    function skyCurrent() { return !!(state.engraving.sky && state.engraving.sky.key === skyInputs()); }
    function ensureSky() {
      /* cria o design no TeeInBlue com os dados de agora (a mesma carga que o tema activo escreve em localStorage) e devolve
         {id, image, link}; se já existe um para estes dados, devolve-o */
      var e = state.engraving;
      if (!tibReady() || !skyInputs()) return Promise.resolve(null);
      if (skyCurrent()) return Promise.resolve(e.sky);
      var tib = config.engraving.tib || {};
      var when = e.date.trim() + 'T' + skyTime();
      var at = new Date(when);
      var customization = { platform_linked_id: String(state.variantId) };
      customization[tib.template] = tib.template_id;
      customization[tib.layer] = {
        lat: e.mapLat, lng: e.mapLng,
        name: (e.mapLabel || e.mapPlace).split(',')[0].trim(),
        place_name: e.mapLabel || e.mapPlace.trim(),
        time: when,
        timezone: isNaN(at.getTime()) ? -new Date().getTimezoneOffset() : -at.getTimezoneOffset(),
        custom_display: {}
      };
      var productId = String(window.teeinblueCampaign.productId);
      try {
        var items = JSON.parse(window.localStorage.getItem('teeinblue-customizations') || '[]');
        if (!Array.isArray(items)) items = [];
        var next = { productId: productId, customization: customization, timestamp: Date.now() };
        var index = items.findIndex(function (item) { return String(item && item.productId) === productId; });
        if (index >= 0) items[index] = next; else items.push(next);
        window.localStorage.setItem('teeinblue-customizations', JSON.stringify(items));
      } catch (err) {}
      if (typeof window.teeinblue.setVariantId === 'function') window.teeinblue.setVariantId(String(state.variantId));
      if (typeof window.teeinblue.reinitCustomizationData === 'function') window.teeinblue.reinitCustomizationData(productId);
      var key = skyInputs();
      return Promise.resolve()
        .then(function () { if (typeof window.teeinblue.refillCustomization === 'function') window.teeinblue.refillCustomization(productId); })
        .then(function () { return window.teeinblue.createCustomization(); })
        .then(function (result) {
          var props = (result && result.properties) || {};
          var id = String(props._customization_id || (result && result.id) || '');
          if (!id) throw new Error('tib');
          var clean = function (v) { return String(v || '').trim().replace(/&amp;/g, '&'); };
          var link = clean(props._tib_design_link_1) || 'https://cdn.teeinblue.com/designs/' + id + '/' + id + '-' + tib.template + '.png';
          state.engraving.sky = { id: id, image: clean(props._customization_image) || link, link: link, key: key };
          return state.engraving.sky;
        });
    }
    var skyRetry = null;
    var skyLoaded = false; /* a imagem do desenho já chegou? enquanto não chega, a janela do céu fica à espera */
    function cropSky(source) {
      /* a imagem da app traz o céu num círculo branco sobre um xadrez: encontra-se o círculo (do bordo para dentro, o primeiro troço
         de ≥ 24 px quase brancos — o xadrez tem quadrados de 6 px) e devolve-se só ele, num PNG com o resto transparente.
         Se o browser não deixar ler os pixels (CORS), devolve-se nada e fica a imagem inteira, recortada em círculo por CSS. */
      try {
        var W = source.naturalWidth, H = source.naturalHeight;
        if (!W || !H) return '';
        var canvas = document.createElement('canvas');
        canvas.width = W; canvas.height = H;
        var ctx = canvas.getContext('2d');
        ctx.drawImage(source, 0, 0);
        var data = ctx.getImageData(0, 0, W, H).data;
        var v = function (x, y) { return data[(y * W + x) * 4]; };
        var edge = function (dx, dy, x, y) {
          for (var i = 0; i < Math.max(W, H); i++) {
            var n = 0;
            while (n < 24) { var xx = x + dx * (i + n), yy = y + dy * (i + n); if (xx < 0 || yy < 0 || xx >= W || yy >= H) return -1; if (v(xx, yy) < 248) break; n++; }
            if (n >= 24) return dx ? x + dx * i : y + dy * i;
          }
          return -1;
        };
        var cx = Math.floor(W / 2), cy = Math.floor(H / 2);
        var left = edge(1, 0, 0, cy), right = edge(-1, 0, W - 1, cy), top = edge(0, 1, cx, 0), bottom = edge(0, -1, cx, H - 1);
        if (left < 0 || right < 0 || top < 0 || bottom < 0) return '';
        var d = Math.min(right - left, bottom - top);
        if (d < W * 0.4) return '';
        var ox = (left + right) / 2 - d / 2, oy = (top + bottom) / 2 - d / 2;
        var size = 600;
        var out = document.createElement('canvas');
        out.width = size; out.height = size;
        var octx = out.getContext('2d');
        octx.beginPath(); octx.arc(size / 2, size / 2, size / 2 - 2, 0, Math.PI * 2); octx.closePath(); octx.clip();
        octx.drawImage(source, ox, oy, d, d, 0, 0, size, size);
        return out.toDataURL('image/png');
      } catch (e) { return ''; }
    }
    function loadSky(url) {
      /* a imagem do TeeInBlue pode levar uns segundos a existir depois de criar o design: tenta de novo até aparecer;
         quando chega, recorta-se ao círculo (cropSky) e guarda-se a versão recortada para a revisão */
      var img = $('[data-flow-sky-img]');
      if (!img || img.getAttribute('data-src') === url) return;
      img.setAttribute('data-src', url);
      img.classList.remove('is-cropped');
      skyLoaded = false;
      clearTimeout(skyRetry);
      var tries = 0;
      var attempt = function () {
        tries += 1;
        var probe = new Image();
        probe.crossOrigin = 'anonymous';
        probe.onerror = function () {
          if (img.getAttribute('data-src') !== url) return;
          if (tries < 12) { skyRetry = setTimeout(attempt, 1500); return; }
          /* desistiu-se: o atelier traça-o à mesma a partir dos dados — dizer isso em vez de deixar a janela à espera para sempre */
          var failed = $('[data-flow-sky-error]');
          if (failed) failed.hidden = false;
          state.engraving.sky = null;
          renderEngraving();
        };
        probe.onload = function () {
          if (img.getAttribute('data-src') !== url) return;
          skyLoaded = true;
          var cropped = cropSky(probe);
          img.src = cropped || probe.src;
          img.classList.toggle('is-cropped', !!cropped);
          if (state.engraving.sky && state.engraving.sky.image === url) {
            state.engraving.sky.preview = cropped || '';
            /* a mesma imagem como URL abrível num separador (um data: não abre): a miniatura da revisão é um link, como as fotografias */
            if (cropped && window.URL && URL.createObjectURL) {
              var sky = state.engraving.sky;
              fetch(cropped).then(function (r) { return r.blob(); }).then(function (blob) { sky.previewUrl = URL.createObjectURL(blob); }).catch(function () {});
            }
          }
          renderEngraving(); /* tira a janela do estado «a traçar» */
        };
        probe.src = url + (url.indexOf('?') > -1 ? '&' : '?') + 'r=' + tries;
      };
      attempt();
    }
    function showSky() {
      var button = $('[data-flow-sky-preview]');
      if (!button || skyBusy) return;
      skyBusy = true;
      button.disabled = true;
      button.textContent = button.getAttribute('data-label-busy');
      $('[data-flow-sky-error]').hidden = true;
      ensureSky()
        .then(function () { renderEngraving(); })
        .catch(function () { $('[data-flow-sky-error]').hidden = false; })
        .then(function () { skyBusy = false; renderEngraving(); });
    }

    /* ---------- o fio (ecrã 1g-01): 45 ou 55 cm ----------
       Não é variante (estes colares só têm a cor): a escolha viaja na encomenda como propriedade de linha «Comprimento do fio». */
    /* tamanho de anel (1h-02): o escolhido, os esgotados nesta cor (com a etiqueta, sem se poderem escolher) e a linha do prazo */
    function renderSize() {
      var out = [];
      $$('[data-flow-size]').forEach(function (chip) {
        var value = chip.getAttribute('data-flow-size');
        var available = sizeAvailable(value);
        if (!available) out.push(chip.getAttribute('data-title'));
        chip.setAttribute('aria-checked', value === state.size ? 'true' : 'false');
        chip.disabled = !available;
        chip.classList.toggle('is-out', !available);
        var tag = chip.querySelector('.engram-flow__size-out');
        if (tag) tag.hidden = available;
      });
      var note = $('[data-flow-size-note]');
      if (!note) return;
      var total = $$('[data-flow-size]').length;
      if (!out.length) note.textContent = note.getAttribute('data-all');
      else if (out.length === total) note.textContent = note.getAttribute('data-none');
      else if (out.length === 1) note.textContent = fill(note.getAttribute('data-one'), { s: out[0] });
      else note.textContent = fill(note.getAttribute('data-many'), { s: out.slice(0, -1).join(', ') + ' ' + note.getAttribute('data-and') + ' ' + out[out.length - 1] });
    }
    function renderChain() {
      $$('[data-flow-chain]').forEach(function (card) {
        var on = card.getAttribute('data-flow-chain') === state.chain;
        card.setAttribute('aria-checked', on ? 'true' : 'false');
        card.setAttribute('tabindex', on ? '0' : '-1');
        card.classList.toggle('is-on', on);
      });
    }

    /* ---------- gravação (ecrã 1f): tipo → palavra · coordenadas · desenho · impressão digital ---------- */
    function coordsPreview(text) {
      /* «41.1403° N, 8.6094° W» → as duas linhas da placa, separadas por «·» */
      var parts = String(text || '').split(/\s*[,;]\s*|\s{2,}/).filter(function (p) { return p.trim(); });
      /* em duas linhas, como nas fotografias de exemplo das peças; numa só nas peças com o metafield
         engram.coordinates_lines = 1, como o Colar com Pendente, a barra vertical (QA do Fábio, 28 e 29 Out) */
      var oneLine = engraving && config.engraving.coords_lines === 1;
      return parts.length > 1 ? parts.join(oneLine ? ' · ' : '\n') : String(text || '').trim();
    }
    /* Colar Morse: o colar em canvas (assets/engram-morse.js). Os desenhos das contas carregam-se uma vez; até chegarem,
       as contas saem lisas. O fundo é o do cartão (token), para o desenho não ter caixa à volta. */
    var morseImages = null;
    function drawMorse() {
      var canvas = $('[data-flow-morse-canvas]');
      if (!canvas || !window.EngramMorse) return;
      var M = window.EngramMorse;
      if (!morseImages) {
        var panel = $('[data-flow-engraving-panel="morse"]');
        morseImages = M.loadImages(panel.getAttribute('data-dot'), panel.getAttribute('data-dash'), function () { drawMorse(); });
      }
      var v = variant();
      M.draw(canvas, state.engraving.text, M.finish((v.options || [v.title]).join(' ')), morseImages, getComputedStyle(canvas.parentNode).backgroundColor);
      var count = M.letters(state.engraving.text).reduce(function (sum, l) { return sum + l.code.length; }, 0);
      canvas.setAttribute('aria-label', count ? fill(canvas.getAttribute('data-label'), { x: morseText(), n: count }) : canvas.getAttribute('data-label-empty'));
    }
    function renderEngraving() {
      if (!engraving) return;
      var e = state.engraving;
      var typeView = $('[data-flow-engraving-view="type"]'); /* não existe no mapa das estrelas: uma forma só, sem escolha */
      var formView = $('[data-flow-engraving-view="form"]');
      if (typeView) typeView.hidden = e.view !== 'type';
      formView.hidden = e.view !== 'form';

      /* cartões das formas de gravar: a fotografia da cor escolhida (metafield da variante), senão a primeira que houver */
      $$('[data-flow-type]').forEach(function (card) {
        card.setAttribute('aria-checked', card.getAttribute('data-flow-type') === e.type ? 'true' : 'false');
        card.setAttribute('tabindex', (e.type ? card.getAttribute('data-flow-type') === e.type : card === $('[data-flow-type]')) ? '0' : '-1');
        var images = Array.prototype.slice.call(card.querySelectorAll('[data-engram-about-variant]'));
        var match = images.filter(function (img) { return img.getAttribute('data-engram-about-variant') === state.variantId; })[0] || images[0];
        images.forEach(function (img) { img.hidden = img !== match; });
      });

      $$('[data-flow-engraving-panel]').forEach(function (panel) { panel.hidden = panel.getAttribute('data-flow-engraving-panel') !== e.type; });

      /* gravação no verso: entra no fim do painel da palavra ou das coordenadas */
      var backBox = $('[data-flow-back-box]');
      if (backBox) {
        var host = backAllowed() ? $('[data-flow-engraving-panel="' + e.type + '"]') : null;
        backBox.hidden = !host;
        if (host && backBox.parentNode !== host) host.appendChild(backBox);
        var on = backOn();
        backBox.querySelector('[data-flow-back-toggle]').setAttribute('aria-checked', on ? 'true' : 'false');
        backBox.querySelector('.engram-flow__opt').classList.toggle('is-on', on);
        var line = backBox.querySelector('[data-flow-back-line]');
        if (backExtra()) line.textContent = fill(line.getAttribute('data-template'), { p: fmt(backExtra().price) });
        var field = backBox.querySelector('[data-flow-back-field]');
        field.hidden = !on;
        var backInput = backBox.querySelector('[data-flow-back-input]');
        if (backInput.value !== e.backText) backInput.value = e.backText;
        var backCounter = backBox.querySelector('[data-flow-back-counter]');
        backCounter.textContent = fill(backCounter.getAttribute('data-template'), { n: e.backText.length, max: backInput.maxLength > 0 ? backInput.maxLength : config.engraving.back_max_chars });
      }

      /* palavra ou mensagem: pré-visualização no tipo de letra escolhido + contador */
      var textInput = $('[data-flow-text-input]');
      if (textInput) {
        if (textInput.value !== e.text) textInput.value = e.text;
        var preview = $('[data-flow-text-preview]');
        var has = e.text.trim().length > 0;
        preview.textContent = has ? e.text : preview.getAttribute('data-empty');
        preview.classList.toggle('is-empty', !has);
        preview.setAttribute('data-font', e.font);
        $$('[data-flow-font]').forEach(function (seg) { seg.setAttribute('aria-checked', seg.getAttribute('data-flow-font') === e.font ? 'true' : 'false'); });
        var counter = $('[data-flow-text-counter]');
        counter.textContent = fill(counter.getAttribute('data-template'), { n: e.text.length, max: textInput.maxLength > 0 ? textInput.maxLength : config.engraving.max_chars });
      }

      /* Colar Morse: contador, a frase do que o atelier monta e o colar desenhado na cor da variante */
      var morseInput = $('[data-flow-morse-input]');
      if (morseInput && window.EngramMorse) {
        var M = window.EngramMorse;
        if (morseInput.value !== e.text) morseInput.value = e.text;
        var morseCounter = $('[data-flow-morse-counter]');
        morseCounter.textContent = fill(morseCounter.getAttribute('data-template'), { n: e.text.length, max: morseInput.maxLength > 0 ? morseInput.maxLength : config.engraving.max_chars });
        var built = morseText();
        /* «Sem acentos, o atelier monta PAI MAE EU» só quando o que se monta não é o que se escreveu */
        var morseHint = $('[data-flow-morse-hint]');
        var adjusted = built && built !== e.text.trim().toUpperCase();
        morseHint.textContent = adjusted ? fill(morseHint.getAttribute('data-adjusted'), { x: built }) : morseHint.getAttribute('data-default');
        $('[data-flow-morse-empty]').hidden = M.letters(e.text).length > 0;
        drawMorse();
      }

      /* coordenadas: o lugar é obrigatório; as coordenadas, quando escritas, mostram-se como ficam na placa */
      var placeInput = $('[data-flow-place-input]');
      if (placeInput) {
        if (placeInput.value !== e.place) placeInput.value = e.place;
        var box = $('[data-flow-coords-preview]');
        box.hidden = !e.coords.trim();
        if (!box.hidden) $('[data-flow-coords-preview-text]').textContent = coordsPreview(e.coords);
        /* a linha «Guimarães, Portugal · 41,4418° N» sai do estado, não do clique na sugestão: a editar
           a partir do saco não houve clique nenhum, e o lugar aparecia por confirmar quando já estava. */
        if (placeFinder) placeFinder.mark(e.place.trim() && e.coords.trim() ? fill(strings.picked, { p: e.place.trim(), c: e.coords.trim() }) : '');
        /* o mapa só existe depois de uma pesquisa; ao voltar ao painel, volta a medir-se (estava escondido) */
        if (mapEl) { var hasPoint = e.lat !== null && e.lng !== null; mapEl.hidden = !hasPoint; var mapHint = $('[data-flow-coords-map-hint]'); if (mapHint) mapHint.hidden = !hasPoint; if (hasPoint && e.type === 'coordinates') showMap(); }
      }

      /* mapa das estrelas (1g-02): lugar, data, hora; o céu (TeeInBlue) aparece depois de «Ver o céu»; sem a app fica a nota.
         O mesmo painel na peça de mapa (pa:laser:star) e na opção de gravação (pa:engraving:star-map) — decisão do utilizador, 23 Set. */
      var dateInput = $('[data-flow-date-input]');
      if (dateInput) {
        if (dateInput.value !== e.date) dateInput.value = e.date;
        var timeInput = $('[data-flow-time-input]');
        if (timeInput.value !== e.time) timeInput.value = e.time;
        var mapPlace = $('[data-flow-map-place-input]');
        if (mapPlace.value !== e.mapPlace) mapPlace.value = e.mapPlace;
        /* a linha «Porto, Portugal · 41,1502° N, 8,6103° W» sai do estado e não do clique na sugestão:
           a editar a partir do saco não houve clique nenhum, e sem isto o lugar aparecia por confirmar
           quando já estava escolhido. Escrever no campo limpa as coordenadas, e a linha some-se com elas. */
        if (mapFinder) {
          mapFinder.mark(e.mapLat !== null && e.mapLng !== null
            ? fill(strings.picked, { p: e.mapLabel || e.mapPlace, c: formatCoordinate(e.mapLat, true) + ', ' + formatCoordinate(e.mapLng, false) })
            : '');
        }
        var ready = tibReady();
        var can = ready && !!skyInputs();
        var current = skyCurrent();
        /* «a traçar o céu»: desde que se pede o desenho até a imagem existir mesmo (o TeeInBlue publica-a com uns segundos de atraso) */
        var waiting = skyBusy || (current && !skyLoaded);
        /* legenda do céu: a traçar, «É este o céu…» com a hora, ou a nota das 22:00 sem ela */
        var skyCaption = $('[data-flow-sky-caption]');
        if (skyCaption) skyCaption.textContent = waiting ? skyCaption.getAttribute('data-busy') : (e.time.trim() ? skyCaption.getAttribute('data-exact') : fill(skyCaption.getAttribute('data-default'), { time: skyTime() }));
        var skyBox = $('[data-flow-sky]');
        skyBox.hidden = !current && !skyBusy; /* a janela aparece logo ao pedir, à espera, e não salta quando o céu chega */
        skyBox.classList.toggle('is-waiting', waiting);
        if (current) loadSky(e.sky.image);
        /* o botão só faz falta enquanto não há céu para estes dados (ou depois de os mudar) */
        var skyButton = $('[data-flow-sky-preview]');
        skyButton.hidden = !can || current || skyBusy;
        if (!skyBusy) { skyButton.disabled = false; skyButton.textContent = skyButton.getAttribute(e.sky && !current ? 'data-label-again' : 'data-label'); }
        $('[data-flow-sky-note]').hidden = ready;
        if (!can) $('[data-flow-sky-error]').hidden = true;
      }

      /* impressão digital: o kit (0 €) */
      var kitImg = $('[data-flow-kit-img]');
      if (kitImg) {
        var kit = config.engraving.kit;
        kitImg.hidden = !(kit && kit.image);
        if (!kitImg.hidden && kitImg.getAttribute('src') !== kit.image) kitImg.src = kit.image;
      }
      /* kit de cera: 1 ou 2 impressões — o cartão escolhido, o 2.º tempo e o aviso «lado a lado» */
      if (countIndex > -1) {
        var count = fpCount();
        $$('[data-flow-fp-count]').forEach(function (card) {
          var on = Number(card.getAttribute('data-flow-fp-count')) === count;
          card.setAttribute('aria-checked', on ? 'true' : 'false');
          card.setAttribute('tabindex', on ? '0' : '-1');
          card.classList.toggle('is-on', on);
        });
        var step2 = $('[data-flow-fp-step2]');
        if (step2) step2.textContent = step2.getAttribute(count === 2 ? 'data-two' : 'data-one');
        var double = $('[data-flow-fp-double]');
        if (double) double.hidden = count !== 2;
      }

      if (e.type === 'artwork') renderPhoto();
    }

    /* ---------- extras ---------- */
    var extrasHost = $('[data-flow-extras]');
    function renderExtras() {
      if (root.querySelector('[data-flow-extra]')) { syncExtras(); return; }
      var maxChars = parseInt(extrasHost.getAttribute('data-message-max'), 10) || 200;
      config.extras.forEach(function (x) {
        if (!x.available) return;
        /* dois passos: «Para oferecer» (saco, cartão com fotografia) e «Extras» (pa:extra:* da peça) — cada um com a sua lista */
        var host = $('[data-flow-extras-group="' + x.group + '"]');
        if (!host) return;
        var wrap = document.createElement('div');
        wrap.className = 'engram-flow__extra' + (x.message ? ' has-message' : '');
        wrap.setAttribute('data-flow-extra', x.variant_id);

        var opt = document.createElement('div');
        opt.className = 'engram-flow__opt';
        var left = document.createElement('div');
        left.className = 'engram-flow__opt-row';
        /* só nas ofertas (saco, cartão): a fotografia e o «i» abrem «Sobre o extra» (openExtraInfo), sem ligar a oferta;
           o resto do cartão liga. Nos extras a fotografia é só uma fotografia (Fábio, 29 Out 2026). */
        var canInfo = x.group === 'gift';
        var infoLabel = fill(extrasHost.getAttribute('data-info-label'), { t: x.title });
        var thumb = document.createElement(canInfo ? 'button' : 'span');
        thumb.className = 'engram-flow__xth';
        if (canInfo) {
          thumb.type = 'button';
          thumb.setAttribute('data-flow-extra-info', x.variant_id);
          thumb.setAttribute('aria-label', infoLabel);
          thumb.setAttribute('aria-haspopup', 'dialog');
        }
        if (x.image) { var im = document.createElement('img'); im.src = x.image; im.alt = ''; im.loading = 'lazy'; thumb.appendChild(im); }
        var text = document.createElement('div');
        var title = document.createElement('b');
        title.id = 'EngramFlowExtra-' + x.variant_id;
        title.textContent = x.title;
        var line = document.createElement('small');
        /* preço em destaque; nas ofertas (saco, cartão) é só o preço, nos extras segue a frase da linha (Fábio, 29 Out) */
        var priceEl = document.createElement('span');
        priceEl.className = 'engram-flow__xprice';
        priceEl.textContent = fmt(x.price);
        line.appendChild(priceEl);
        if (x.group !== 'gift' && x.line) line.appendChild(document.createTextNode(' · ' + x.line));
        text.appendChild(title); text.appendChild(line);
        left.appendChild(thumb); left.appendChild(text);
        var tog = document.createElement('button');
        tog.type = 'button';
        tog.className = 'engram-flow__tog';
        tog.setAttribute('role', 'switch');
        tog.setAttribute('aria-labelledby', title.id);
        tog.setAttribute('aria-label', fill(extrasHost.getAttribute('data-toggle-label'), { t: x.title }));
        tog.setAttribute('data-flow-extra-toggle', x.variant_id);
        var end = document.createElement('span');
        end.className = 'engram-flow__opt-end';
        if (canInfo) {
          var info = document.createElement('button');
          info.type = 'button';
          info.className = 'engram-flow__xinfo';
          /* um «i» minúsculo desenhado (ponto e haste), para o ponto se ver mesmo em 20px */
          info.innerHTML = '<svg viewBox="0 0 20 20" width="20" height="20" aria-hidden="true" focusable="false"><circle cx="10" cy="5.6" r="1.5" fill="currentColor"/><rect x="8.9" y="8.6" width="2.2" height="6.8" rx="1.1" fill="currentColor"/></svg>';
          info.setAttribute('data-flow-extra-info', x.variant_id);
          info.setAttribute('aria-label', infoLabel);
          info.setAttribute('aria-haspopup', 'dialog');
          end.appendChild(info);
        }
        end.appendChild(tog);
        opt.appendChild(left); opt.appendChild(end);
        wrap.appendChild(opt);

        if (x.photo) wrap.classList.add('has-message'); /* o painel da fotografia entra aqui (renderCard) */
        if (x.message) {
          var box = document.createElement('div');
          box.className = 'engram-flow__message';
          box.hidden = true;
          var label = document.createElement('label');
          label.className = 'visually-hidden';
          label.setAttribute('for', 'EngramFlowMessage-' + x.variant_id);
          label.textContent = extrasHost.getAttribute('data-message-label');
          var area = document.createElement('textarea');
          area.id = 'EngramFlowMessage-' + x.variant_id;
          area.maxLength = maxChars;
          area.rows = 2;
          area.placeholder = extrasHost.getAttribute('data-message-placeholder');
          area.setAttribute('data-flow-message', '');
          var counter = document.createElement('span');
          counter.className = 'engram-caption';
          counter.setAttribute('data-flow-message-counter', '');
          box.appendChild(label); box.appendChild(area); box.appendChild(counter);
          wrap.appendChild(box);
          area.addEventListener('input', function () { state.message = area.value; counter.textContent = fill(extrasHost.getAttribute('data-counter'), { n: area.value.length, max: maxChars }); renderFoot(); save(); }); /* renderFoot: «Continuar» só com algo escrito */
        }
        host.appendChild(wrap);
      });
      syncExtras();
    }
    function syncExtras() {
      var maxChars = parseInt(extrasHost.getAttribute('data-message-max'), 10) || 200;
      $$('[data-flow-extra]').forEach(function (wrap) {
        var id = wrap.getAttribute('data-flow-extra');
        var on = !!state.extras[id];
        wrap.querySelector('.engram-flow__opt').classList.toggle('is-on', on);
        wrap.querySelector('[data-flow-extra-toggle]').setAttribute('aria-checked', on ? 'true' : 'false');
        var box = wrap.querySelector('.engram-flow__message:not([data-flow-photocard])'); /* o painel da fotografia do cartão tem outro tratamento (renderCard) */
        if (box) {
          box.hidden = !on;
          var area = box.querySelector('textarea');
          if (area.value !== state.message) area.value = state.message;
          box.querySelector('[data-flow-message-counter]').textContent = fill(extrasHost.getAttribute('data-counter'), { n: state.message.length, max: maxChars });
        }
      });
      syncBundle();
      renderCard();
    }
    /* o cartão do pack: preços (soma dos 4 riscada, metade, «Poupe …») e estado ligado/desligado */
    function syncBundle() {
      var card = $('[data-flow-bundle]');
      if (!card) return;
      card.hidden = !bundleAvailable();
      if (card.hidden) return;
      var full = bundleExtras().reduce(function (sum, x) { return sum + x.price; }, 0);
      var saving = bundleAllSaving(); /* o cartão anuncia o que se poupa levando os quatro */
      $('[data-flow-bundle-compare]').textContent = fmt(full);
      $('[data-flow-bundle-price]').textContent = fmt(full - saving);
      ['[data-flow-bundle-text]', '[data-flow-bundle-save]'].forEach(function (sel) { var el = $(sel); el.textContent = fill(el.getAttribute('data-template'), { s: fmt(saving) }); });
      card.classList.toggle('is-on', bundleAllPicked());
      card.setAttribute('aria-pressed', bundleAllPicked() ? 'true' : 'false');
    }

    /* ---------- rever ---------- */
    function renderReview() {
      var v = variant();
      $('[data-flow-review-img]').src = v.image || config.product.image;
      $('[data-flow-review-price]').textContent = fmt(v.price);
      /* na revisão o fio entra na linha da peça («Gold · aço · 45 cm»); no cartão do topo dos passos não — é a peça, ainda sem escolhas */
      $('[data-flow-review-line]').textContent = [variantLine(), sizeLabel(), chainLabel()].filter(Boolean).join(' · '); /* «Gold · aço · 16 mm» */

      /* miniaturas lado a lado: uma, ou as duas nas peças de duas fotografias (a mesma repetida com «mesma foto»); no desenho, uma quadrada */
      var thumbs = $('[data-flow-review-thumb]');
      var isSky = engraving && state.engraving.type === 'star_map' && skyCurrent();
      var photos = (engraving && state.engraving.type !== 'artwork') ? [] : piecePhotos().slice(0, dual ? 2 : 1);
      if (dual && state.sameTwice && photos.length === 1) photos.push(photos[0]);
      thumbs.hidden = !(state.photo.status === 'ready' && photos.length);
      thumbs.textContent = '';
      var slotLabel = $('[data-flow-photocard-options]') ? $('[data-flow-photocard-options]').getAttribute('data-label-slot') : '';
      if (!thumbs.hidden) photos.forEach(function (photo, i) {
        /* cada miniatura abre a sua fotografia (nas peças de duas, é assim que se vêem as duas) */
        var box = document.createElement(photo.direct ? 'a' : 'span');
        box.className = 'engram-flow__review-thumb' + (engraving ? ' engram-flow__review-thumb--drawing' : ''); /* desenho: quadrada, com o aro céu como as fotografias */
        if (photo.direct) { box.href = photo.direct; box.target = '_blank'; box.rel = 'noopener'; box.setAttribute('aria-label', dual && slotLabel ? fill(slotLabel, { n: i + 1 }) : $('[data-flow-review-preview]').textContent); }
        var img = document.createElement('img');
        img.src = photo.thumb || ''; img.alt = ''; img.width = 22; img.height = 22;
        box.appendChild(img);
        thumbs.appendChild(box);
      });
      /* impressão digital: a miniatura quadrada e pequena do kit; mapa das estrelas: o céu recortado, redondo e um pouco maior,
         como a fotografia na microfoto (pedido do utilizador, 22 Set) */
      var small = kitExtra() && kitExtra().image ? kitExtra().image : (isSky ? (state.engraving.sky.preview || state.engraving.sky.image) : '');
      if (small) {
        thumbs.hidden = false;
        /* o céu abre num separador ao tocar, como as fotografias (o recorte em blob:, senão a imagem da app) */
        var skyHref = isSky ? (state.engraving.sky.previewUrl || state.engraving.sky.image) : '';
        var kitBox = document.createElement(skyHref ? 'a' : 'span');
        kitBox.className = isSky ? 'engram-flow__review-thumb engram-flow__review-thumb--sky' : 'engram-flow__review-thumb engram-flow__review-thumb--square engram-flow__review-thumb--kit';
        if (skyHref) { kitBox.href = skyHref; kitBox.target = '_blank'; kitBox.rel = 'noopener'; kitBox.setAttribute('aria-label', $('[data-flow-review-preview]').textContent); }
        var kitImg = document.createElement('img');
        kitImg.src = small; kitImg.alt = ''; kitImg.width = isSky ? 28 : 18; kitImg.height = isSky ? 28 : 18;
        kitBox.appendChild(kitImg);
        thumbs.appendChild(kitBox);
      }
      $('[data-flow-review-photo-text]').textContent = personalizationLabel('review');
      /* peça fundadora (sem fotografia): a mesma barra azul, de uma linha, com o lugar entre os Founding Thirty (só com lugares livres) */
      var reviewBox = $('[data-flow-review-photo]');
      if (plain) {
        /* como no saco: a caixa vai para debaixo das opções da peça, ao lado da fotografia (pedido do Fábio, 19 Out) */
        var pieceText = $('.engram-flow__review-piece-text');
        if (pieceText && reviewBox.parentNode !== pieceText) pieceText.appendChild(reviewBox);
        reviewBox.hidden = !strings.review_founding;
        $('[data-flow-review-photo-text]').textContent = strings.review_founding;
        thumbs.hidden = true;
        if (mark) mark.hidden = false;
        /* sem «Editar»: aqui não há nada para mudar (pedido do Fábio, 19 Out); o fio muda-se pelo «←» */
      } else {
        reviewBox.hidden = false;
      }
      /* o ✓ só quando não há miniatura: com imagem, é ela que diz que está escolhido (como no saco) */
      var mark = $('[data-flow-review-mark]');
      if (mark) mark.hidden = !thumbs.hidden;
      /* os quatro tempos do kit só na impressão digital, que é a única peça que espera pela fotografia */
      var kitLine = $('[data-flow-review-kit]');
      if (kitLine) kitLine.hidden = !(engraving && state.engraving.type === 'fingerprint');
      /* «· ver» (ou «· ver 1 · ver 2»): links de texto para as imagens guardadas — a miniatura sozinha não se anuncia como clicável */
      var linksBox = $('[data-flow-review-links]');
      linksBox.textContent = '';
      var links = [];
      if (!thumbs.hidden && photos.length) photos.forEach(function (photo, i) { if (photo.direct) links.push({ href: photo.direct, label: photos.length > 1 ? fill(linksBox.getAttribute('data-label-n'), { n: i + 1 }) : linksBox.getAttribute('data-label') }); });
      if (isSky) links.push({ href: state.engraving.sky.previewUrl || state.engraving.sky.image, label: linksBox.getAttribute('data-label') });
      links.forEach(function (link, i) {
        linksBox.appendChild(document.createTextNode(i ? ' · ' : '· ')); /* o espaço antes do primeiro «·» é o gap da linha (o inicial seria cortado) */
        var a = document.createElement('a');
        a.className = 'engram-flow__textlink';
        a.href = link.href; a.target = '_blank'; a.rel = 'noopener';
        a.textContent = link.label;
        linksBox.appendChild(a);
      });
      /* impressão digital: o kit vai sozinho — «Editar» só quando há verso ou n.º de impressões para mudar (pedido do utilizador, 28 Set) */
      $('.engram-flow__review-edit').hidden = plain || (engraving && state.engraving.type === 'fingerprint' && !backExtra() && countIndex < 0);
      var preview = $('[data-flow-review-preview]');
      preview.hidden = true; /* a miniatura é o link: tocar nela abre a fotografia (pedido do utilizador, 22 Set) */

      var list = $('[data-flow-review-extras-list]');
      list.textContent = '';
      var addRow = function (label, price, sub) {
        var row = document.createElement('div');
        row.className = 'engram-flow__kv';
        var name = document.createElement('span');
        name.textContent = label;
        var value = document.createElement('span');
        value.textContent = price;
        row.appendChild(name); row.appendChild(value);
        list.appendChild(row);
        if (sub) list.appendChild(sub);
      };
      /* O texto que o cliente escreveu vai SEMPRE numa linha por baixo, recuado e entre aspas — a carta e a
         gravação no verso tratam-se da mesma maneira. Com mais de 40 caracteres, «ver toda» abre-a. */
      var quoteSub = function (text) {
        var sub = document.createElement('span');
        sub.className = 'engram-caption engram-flow__review-sub engram-flow__review-sub--text is-clamped';
        var quote = document.createElement('span');
        quote.className = 'engram-flow__review-quote';
        quote.textContent = fill(strings.review_message_sub, { m: text });
        sub.appendChild(quote);
        if (text.length > 40) {
          var more = document.createElement('button');
          more.type = 'button';
          more.className = 'engram-flow__textlink engram-flow__review-more';
          more.setAttribute('data-flow-review-more', '');
          more.setAttribute('data-label', strings.review_message_more);
          more.setAttribute('data-label-less', strings.review_message_less);
          more.textContent = strings.review_message_more;
          sub.appendChild(more);
        }
        return sub;
      };
      /* a gravação no verso e o kit de impressão digital são linhas próprias, como os extras */
      if (backOn()) addRow(backExtra().title, fmt(backExtra().price), quoteSub(state.engraving.backText.trim()));
      if (kitExtra()) addRow(kitExtra().title, kitExtra().price > 0 ? fmt(kitExtra().price) : strings.included);
      var chosen = selectedExtras();
      $('[data-flow-review-extras]').hidden = false; /* a linha dos extras aparece sempre: sem extras também se pode voltar */
      /* «Adicionar extras» sem ofertas nem extras escolhidos, «Mudar extras» com (Fábio, 29 Out 2026) */
      var changeBtn = $('[data-flow-review-change]');
      if (changeBtn) changeBtn.textContent = changeBtn.getAttribute(chosen.length ? 'data-label-change' : 'data-label-add');
      chosen.forEach(function (x) {
        var label = x.title;
        var sub = null;
        /* a mensagem da carta por baixo da linha, recuada (pedido do utilizador, 22 Set) — o mesmo que a
           gravação no verso leva acima */
        if (x.message && state.message.trim()) sub = quoteSub(state.message.trim());
        if (x.photo) {
          /* por baixo do cartão: miniatura quadrada + «Fotografia guardada» */
          var picked = cardChosen();
          if (picked) {
            sub = document.createElement('span');
            sub.className = 'engram-caption engram-flow__review-sub';
            if (picked.thumb) {
              /* a miniatura quadrada é o link para a fotografia do cartão, como as redondas da peça */
              var thumbBox = document.createElement(picked.direct ? 'a' : 'span');
              thumbBox.className = 'engram-flow__review-thumb engram-flow__review-thumb--square';
              if (picked.direct) { thumbBox.href = picked.direct; thumbBox.target = '_blank'; thumbBox.rel = 'noopener'; thumbBox.setAttribute('aria-label', $('[data-flow-review-preview]').textContent); }
              var thumbImg = document.createElement('img');
              thumbImg.src = picked.thumb; thumbImg.alt = ''; thumbImg.width = 22; thumbImg.height = 22;
              thumbBox.appendChild(thumbImg);
              sub.appendChild(thumbBox);
            }
            var subText = document.createElement('span');
            /* «Fotografia», como na linha da peça; se o cartão espera pela fotografia da peça, diz que vai depois da compra */
            subText.textContent = strings.review_photo_saved;
            sub.appendChild(subText);
            if (picked.direct) {
              /* «· ver» também aqui, dentro do mesmo texto para não apanhar o gap da linha (pedido do utilizador, 22 Set) */
              subText.appendChild(document.createTextNode(' · '));
              var see = document.createElement('a');
              see.className = 'engram-flow__textlink';
              see.href = picked.direct; see.target = '_blank'; see.rel = 'noopener';
              see.textContent = $('[data-flow-review-links]').getAttribute('data-label');
              subText.appendChild(see);
            }
          }
        }
        addRow(label, fmt(x.price), sub);
      });
      /* pack dos extras: linha do desconto, a negativo, por baixo dos extras (a Shopify aplica-o no saco).
         Só aparece quando o saco chega aos quatro — se não chegar, não há desconto nenhum a anunciar. */
      /* lentes de Fundador: uma linha por lente, «Incluída» com o preço riscado (o desconto «The Memory Club · Fundadores» põe-nas a 0 €) */
      for (var li = 0; li < lensCount(); li++) {
        /* como o cartão com fotografia: miniatura (redonda, como a lente) que abre a fotografia, «Fotografia · Ver» */
        var lensData = state.lenses.slots[li];
        var lensDirectProp = lensData.props.filter(function (lp) { return /direct link/i.test(lp.name); })[0] || lensData.props.filter(function (lp) { return lp.name.charAt(0) !== '_'; })[0];
        var lensDirect = lensDirectProp ? lensDirectProp.value : '';
        var lensSub = document.createElement('span');
        lensSub.className = 'engram-caption engram-flow__review-sub';
        if (lensData.thumb) {
          var lensThumb = document.createElement(lensDirect ? 'a' : 'span');
          lensThumb.className = 'engram-flow__review-thumb';
          if (lensDirect) { lensThumb.href = lensDirect; lensThumb.target = '_blank'; lensThumb.rel = 'noopener'; lensThumb.setAttribute('aria-label', $('[data-flow-review-preview]').textContent); }
          var lensImg = document.createElement('img');
          lensImg.src = lensData.thumb; lensImg.alt = ''; lensImg.width = 22; lensImg.height = 22;
          lensThumb.appendChild(lensImg);
          lensSub.appendChild(lensThumb);
        }
        var lensText = document.createElement('span');
        lensText.textContent = strings.review_photo_saved;
        lensSub.appendChild(lensText);
        if (lensData.props.length && lensDirect) {
          lensText.appendChild(document.createTextNode(' · '));
          var lensSee = document.createElement('a');
          lensSee.className = 'engram-flow__textlink';
          lensSee.href = lensDirect; lensSee.target = '_blank'; lensSee.rel = 'noopener';
          lensSee.textContent = $('[data-flow-review-links]').getAttribute('data-label');
          lensText.appendChild(lensSee);
        }
        addRow(fill(strings.lens_row, { n: li + 1 }), strings.lens_included, lensSub);
        var lensWas = document.createElement('s');
        lensWas.textContent = fmt(config.lens.price).replace(/[.,]00(?!\d)/, '');
        var lensValue = lensSub.previousElementSibling.lastElementChild;
        lensValue.appendChild(document.createTextNode(' '));
        lensValue.appendChild(lensWas);
      }
      if (bundleSaving() > 0) addRow(strings.review_bundle, '−' + fmt(bundleSaving()));
      $('[data-flow-review-total]').textContent = fmt(total());

      var lead = $('[data-flow-review-lead]');
      var text;
      if (engraving && state.engraving.type === 'fingerprint') {
        /* impressão digital: o kit chega primeiro (data em negrito, como o prazo normal); a gravação começa quando a fotografia chegar */
        var kitDays = config.engraving.kit_days || [2, 3];
        var kitRange = leadRange(kitDays[0], kitDays[1], config.locale);
        text = fill(lead.getAttribute('data-template-fingerprint'), { range: '<b>' + kitRange + '</b>' + (config.cart.market_pt ? ' (PT)' : ''), days: config.lead.days });
      } else {
        /* com o extra «Produção prioritária» escolhido, valem os prazos dele (metaobjecto «Engram · Prazos») */
        var prio = config.lead.priority;
        var days = prio && selectedExtras().some(function (x) { return x.handle === prio.handle; }) ? prio : config.lead;
        var range = leadRange(days.min, days.max, config.locale);
        text = fill(lead.getAttribute('data-template'), { days: days.days, range: '<b>' + range + '</b>' + (config.cart.market_pt ? ' (PT)' : '') });
      }
      if (config.cart.free_shipping_min > 0 && total() >= config.cart.free_shipping_min) text += ' · ' + lead.getAttribute('data-free-shipping');
      lead.innerHTML = text;
      $('[data-flow-add-error]').hidden = true;
    }

    /* ---------- adicionado ---------- */
    function renderAdded() {
      var v = variant();
      var chosen = selectedExtras();
      /* a editar, o ecrã é o mesmo mas não se diz «adicionada»: a peça já lá estava, mudou */
      var banner = $('[data-flow-added-banner]');
      var addedHeading = $('[data-flow-added-heading]');
      if (banner) banner.textContent = banner.getAttribute(state.edit ? 'data-banner-edit' : 'data-banner');
      if (addedHeading) addedHeading.textContent = addedHeading.getAttribute(state.edit ? 'data-heading-edit' : 'data-heading');
      var text = $('[data-flow-added-text]');
      var names = chosen.map(function (x) { return x.title.toLowerCase(); });
      if (backOn()) names.unshift(backExtra().title.toLowerCase());
      var extrasCount = names.length;
      if (lensCount()) names.push(lensLabel());
      var joined = names.length > 1 ? names.slice(0, -1).join(', ') + ' ' + strings.list_and + ' ' + names[names.length - 1] : names[0] || '';
      var fingerprint = engraving && state.engraving.type === 'fingerprint';
      var key = (fingerprint ? 'data-template-fingerprint' : 'data-template') + (names.length ? '-extras' : '');
      if (plain) key = 'data-template-plain' + (names.length ? '-extras' : '');
      text.textContent = fill(text.getAttribute(key) || text.getAttribute('data-template'), { x: joined });
      $('[data-flow-added-img]').src = v.image || config.product.image;
      $('[data-flow-added-name]').textContent = [config.product.title, optionLabels(v).join(' · '), chainLabel()].filter(Boolean).join(' · ');
      var parts = plain ? [] : [personalizationLabel('added')];
      if (lensCount()) parts.push(lensLabel());
      if (extrasCount) parts.push(extrasCount === 1 ? strings.added_extras_one : fill(strings.added_extras_other, { n: extrasCount }));
      $('[data-flow-added-line]').textContent = parts.join(' · ');
      $('[data-flow-added-price]').textContent = fmt(total());
      $('[data-flow-checkout]').href = config.cart.checkout_url;

      var bag = $('[data-flow-added-bag]');
      var cart = state.added || {};
      /* a Key (ecrã 6d): o cartão só aparece com ela mesmo no saco — o saco junta-a um instante depois
         (assets/engram-cart.js), e então este passo volta a desenhar-se (ver «eventos»). Regra em snippets/engram-key-offer */
      var keyCard = $('[data-flow-added-key]');
      var keyVariant = keyCard ? parseInt(keyCard.getAttribute('data-key-variant'), 10) : 0;
      var keyItem = keyVariant && cart.items ? cart.items.filter(function (item) { return item.variant_id === keyVariant; })[0] : null;
      if (keyCard) {
        keyCard.hidden = !keyItem;
        if (keyItem) {
          var keyFree = keyItem.final_line_price === 0;
          var keyPrice = keyCard.querySelector('[data-flow-added-key-price]');
          keyPrice.textContent = keyFree ? keyCard.getAttribute('data-included') : fmt(keyItem.final_line_price).replace(/[.,]00(?!\d)/, ''); /* «€40», sem cêntimos */
          if (keyFree && keyItem.original_line_price > 0) {
            var was = document.createElement('s');
            was.textContent = fmt(keyItem.original_line_price).replace(/[.,]00(?!\d)/, ''); /* «€40», sem cêntimos, como no desenho e no rever */
            keyPrice.appendChild(document.createTextNode(' '));
            keyPrice.appendChild(was);
          }
          /* «Oferta» só na Key que o saco pôs (ou já a 0 €), como no saco (snippets/engram-key-line) */
          var keyGift = keyFree || !!(keyItem.properties && keyItem.properties[strings.prop_key_gift]);
          keyCard.querySelector('[data-flow-added-key-badge]').hidden = !keyGift;
          if (!state.edit) {
            if (addedHeading) addedHeading.textContent = keyCard.getAttribute('data-heading');
            /* a frase da Key traz o número a negrito: vem do Liquid (data-text), por isso entra como HTML num span próprio */
            var keyText = document.createElement('span');
            keyText.innerHTML = ' ' + keyCard.getAttribute('data-text');
            text.appendChild(keyText);
          }
        }
      }
      /* «peças» = linhas do saco que não são extras (os extras trazem a propriedade «_Artigo principal») nem a Key */
      var count = cart.items ? cart.items.filter(function (item) { return !(item.properties && item.properties[strings.prop_main_item]) && item.variant_id !== keyVariant; }).length : 1;
      var cartTotal = cart.total_price || total();
      var bagFrom = keyItem ? keyCard : bag;
      var line = fill(bagFrom.getAttribute(keyItem ? (count === 1 ? 'data-bag-one' : 'data-bag-other') : (count === 1 ? 'data-one' : 'data-other')), { n: count, total: fmt(cartTotal) });
      if (config.cart.market_pt && config.cart.free_shipping_min > 0 && cartTotal >= config.cart.free_shipping_min) line += ' · ' + bag.getAttribute('data-free-shipping');
      bag.textContent = line;
    }

    /* ---------- rodapé, progresso, navegação ---------- */
    function renderFoot() {
      var step = state.step;
      foot.hidden = step === 'added';
      foot.classList.toggle('engram-flow__foot--review', step === 'review');
      $('[data-flow-summary]').hidden = false; /* na revisão o resumo só se vê no desktop (CSS): «A sua peça · Colar Manus · Silver · 2 extras» */
      $('[data-flow-foot-note]').hidden = step !== 'review';
      $('[data-flow-discard]').hidden = step !== 'review' || !state.edit;
      var v = variant();
      /* rótulo do resumo: «Gravação incluída» ao escolher a forma, «Kit incluído» na impressão digital, senão «A sua peça até aqui» */
      var label = $('[data-flow-summary-label]');
      var labelKey = 'data-default';
      if (step === 'review') labelKey = 'data-piece';
      if (step === 'chain') labelKey = 'data-chain'; /* 1g-01: «Fio incluído» */
      if (step === 'memory' && state.engraving.view === 'type') labelKey = 'data-engraving';
      else if (step === 'memory' && state.engraving.type === 'fingerprint') labelKey = 'data-kit';
      label.textContent = label.getAttribute(labelKey);
      var addons = extrasTotal() + backTotal() - bundleDiscount();
      if (step === 'review') {
        /* ecrã 1o-07: nome da peça, opções e quantos extras (a gravação no verso conta; o kit incluído não) */
        var count = selectedExtras().length + (backOn() ? 1 : 0);
        var pieces = [config.product.title].concat(optionLabels(v));
        if (chainLabel()) pieces.push(chainLabel());
        if (count) pieces.push(count === 1 ? strings.added_extras_one : fill(strings.added_extras_other, { n: count }));
        summaryLine.textContent = pieces.join(' · ');
      }
      else if ((step === 'gift' || step === 'extras') && addons > 0) summaryLine.textContent = fill(strings.summary_extras, { p: fmt(v.price), x: fmt(addons) });
      else if (step === 'memory' && backOn()) summaryLine.textContent = fill(strings.summary_back, { p: fmt(v.price), b: fmt(backExtra().price) });
      else {
        var parts = [fmt(v.price)].concat(optionLabels(v));
        if (chainLabel()) parts.push(chainLabel()); /* 1g: «€39,90 · Gold · 45 cm» */
        /* o «✓» da personalização só depois de se passar por ela: com um passo antes (o fio, 1g-01) dizia-se feita à entrada */
        if (engraving) { if (steps.indexOf(step) > steps.indexOf('memory') && state.engraving.type) parts.push(engravingLabel('summary')); }
        else if (state.photo.status === 'ready') parts.push(photoLabel('summary'));
        summaryLine.textContent = parts.join(' · ');
      }
      if (step === 'review') {
        /* a editar (1o-06) o mesmo botão guarda em vez de adicionar, e a nota diz que substitui a peça */
        var keys = state.edit
          ? { busy: 'data-label-saving', retry: 'data-label-retry-save', go: 'data-label-save' }
          : { busy: 'data-label-adding', retry: 'data-label-retry', go: 'data-label-add' };
        next.textContent = fill(next.getAttribute(state.adding ? keys.busy : (state.addError ? keys.retry : keys.go)), { p: fmt(total()) });
        next.disabled = state.adding;
        var note = $('[data-flow-foot-note]');
        note.textContent = note.getAttribute(state.edit ? 'data-note-edit' : 'data-note');
      } else {
        next.textContent = next.getAttribute('data-label-next');
        var blocked = false;
        if (step === 'size') blocked = !state.size;
        if (step === 'photo') blocked = !photoDone();
        if (step === 'lenses') blocked = !lensesDone();
        if (step === 'memory') blocked = state.engraving.view === 'type' ? !state.engraving.type : !memoryDone();
        if (step === 'gift') blocked = !cardComplete() || messageMissing('gift');
        if (step === 'extras') blocked = messageMissing('extras');
        next.disabled = blocked;
      }
    }

    function renderProgress() {
      /* segmentos = trilho da secção (fotografia/gravação · oferta · extras · rever); os passos que a peça não tem (ex.: extras) somem */
      var allCrumbs = $$('[data-flow-crumb-step]');
      var allBars = $$('[data-flow-progress] span');
      var seps = $$('[data-flow-crumb-sep]');
      allCrumbs.forEach(function (el, i) {
        var name = el.getAttribute('data-flow-crumb-step');
        /* «memory-form» = a personalização, a etapa a seguir à escolha da forma (só na gravação) */
        var present = name === 'memory-form' ? engraving && steps.indexOf('memory') > -1 : steps.indexOf(name) > -1;
        el.hidden = !present;
        if (allBars[i]) allBars[i].hidden = !present;
        if (i > 0 && seps[i - 1]) seps[i - 1].hidden = !present;
      });
      var crumbs = allCrumbs.filter(function (el) { return !el.hidden; });
      var bars = allBars.filter(function (bar) { return !bar.hidden; });
      var segments = crumbs.map(function (el) { return el.getAttribute('data-flow-crumb-step'); });
      var stepOf = function (name) { return /^photo/.test(name) ? 'photo' : name; };
      /* «memory-form» só existe quando a escolha da forma e a personalização são duas etapas (gravação). No mapa das estrelas
         há uma etapa só: sem esta salvaguarda o índice dava −1 e nenhuma etapa ficava marcada como a actual. */
      var current = state.step === 'memory' && state.engraving.view === 'form' && segments.indexOf('memory-form') > -1 ? 'memory-form' : state.step;
      var index = segments.map(stepOf).indexOf(current);
      bars.forEach(function (bar, i) {
        bar.classList.toggle('is-done', i < index);
        bar.classList.toggle('is-now', i === index);
      });
      crumbs.forEach(function (el, i) {
        el.classList.toggle('is-now', i === index);
        /* o «✓» dos passos feitos é um span próprio: no telemóvel esconde-se (a barra escura já diz que estão feitos) para o trilho
           de cinco etapas caber numa linha a 390 */
        el.textContent = el.getAttribute('data-label');
        if (i < index) { var tick = document.createElement('span'); tick.className = 'engram-flow__crumb-tick'; tick.textContent = ' ✓'; el.appendChild(tick); }
      });
      /* desktop: o «voltar» diz para onde vai («← Extras»); no primeiro passo, «← Voltar à peça» */
      var backText = $('[data-flow-back-text]');
      if (backText) {
        var previous = index > 0 ? crumbs[index - 1].getAttribute('data-label') : ''; /* na personalização dá «← Gravação» (a escolha da forma) */
        backText.textContent = previous ? '← ' + previous.charAt(0).toUpperCase() + previous.slice(1) : backText.getAttribute('data-default');
      }
      var hide = state.step === 'added';
      $('[data-flow-progress]').hidden = hide;
      $('[data-flow-crumb]').hidden = hide;
      $('[data-flow-top]').classList.toggle('engram-flow__top--added', hide);
      $('[data-flow-back]').hidden = hide;
      if (!hide) $('[data-flow-progress-label]').textContent = fill(strings.progress, { c: index + 1, t: segments.length });
    }

    function focusHeading(step) {
      var section = $('[data-flow-step="' + step + '"]');
      var headings = section ? Array.prototype.slice.call(section.querySelectorAll('h2')) : [];
      var heading = headings.filter(function (h) { return !h.closest('[hidden]'); })[0];
      if (heading) { heading.setAttribute('tabindex', '-1'); heading.focus({ preventScroll: true }); }
    }
    function go(step) {
      state.step = step;
      track('flow_step', { step: step });
      $$('[data-flow-step]').forEach(function (section) { section.hidden = section.getAttribute('data-flow-step') !== step; });
      if (step === 'size') renderSize();
      if (step === 'chain') renderChain();
      if (step === 'photo') renderPhoto();
      if (step === 'lenses') renderLenses();
      if (step === 'memory') { if (state.engraving.type && engravingTypes.length === 1) state.engraving.view = 'form'; renderEngraving(); }
      if (step === 'gift' || step === 'extras') renderExtras();
      if (step === 'review') renderReview();
      if (step === 'added') renderAdded();
      renderProgress();
      renderFoot();
      body.scrollTop = 0;
      focusHeading(step);
    }
    function showEngravingView(view) {
      state.engraving.view = view;
      renderEngraving(); renderProgress(); renderFoot();
      body.scrollTop = 0;
      focusHeading('memory');
    }
    function forward() {
      var i = steps.indexOf(state.step);
      if (state.step === 'size' && !state.size) return;
      if (state.step === 'photo' && !photoDone()) return;
      if (state.step === 'lenses' && !lensesDone()) return;
      if (state.step === 'memory') {
        /* da escolha da forma para o painel dela; do painel para a oferta */
        if (state.engraving.view === 'type') { if (state.engraving.type) showEngravingView('form'); return; }
        if (!memoryDone()) return;
      }
      if (state.step === 'review') {
        if (sizeIndex > -1 && !state.size) { go('size'); return; } /* nunca vai para o saco um anel sem tamanho escolhido */
        addToBag(); return;
      }
      if (i < steps.length - 1) go(steps[i + 1]);
    }
    function backward() {
      var i = steps.indexOf(state.step);
      if (state.step === 'memory' && state.engraving.view === 'form' && engravingTypes.length > 1) { showEngravingView('type'); return; }
      if (i <= 0 || state.step === 'added') { close(); return; }
      go(steps[i - 1]);
    }

    /* ---------- abrir / fechar ---------- */
    /* ---------- Editar a partir do saco (ecrã 1o-06) ----------
       O fluxo só existe na página da peça, por isso o saco manda para cá com «?engram_edit=<chave da linha>».
       Aqui vai-se buscar essa linha ao carrinho e reconstrói-se o estado a partir das propriedades que o
       próprio fluxo escreveu quando a peça entrou. A fotografia não se volta a enviar: as propriedades da
       app (os links) copiam-se tal como estão e só mudam se o cliente enviar outra. */
    function ourPropertyNames() {
      var names = [
        strings.prop_chain, strings.prop_type, strings.prop_text, strings.prop_font, strings.prop_place,
        strings.prop_coordinates, strings.prop_date, strings.prop_time, strings.prop_back_on_piece,
        strings.prop_place_visible, strings.prop_coordinates_visible, strings.prop_date_visible,
        strings.prop_fine_tune, strings.prop_same_twice, strings.prop_main_item, strings.prop_key,
        strings.prop_message, strings.prop_tib_id, strings.prop_tib_image, strings.prop_tib_link,
        strings.prop_map_data, strings.prop_morse_text, strings.prop_morse_code
      ];
      return names.filter(Boolean);
    }

    /* O endereço que a app guarda na linha não é o do ficheiro: é uma página de descarga com o identificador
       em «uu=» e as operações em «mo=». Para o devolver à app reconstrói-se o endereço da CDN — com o recorte
       que o cliente fez, mas SEM a moldura redonda, que é dela e que ela volta a pôr (senão ficavam duas). */
    function uploadkitSeedUrl(value) {
      var uu = (String(value).match(/[?&]uu=([0-9a-f-]{36})/i) || [])[1];
      if (!uu) return '';
      var mo = (String(value).match(/[?&]mo=([^&]*)/) || [])[1] || '';
      try { mo = decodeURIComponent(mo); } catch (e) {}
      return 'https://ucarecdn.com/' + uu + '/' + withoutOverlay(mo);
    }

    /* Devolve à app do upload as fotografias que já estão na peça, para ela poder trocá-las e afinar o
       recorte. UploadKit.addFilesFromUuids aceita endereços da CDN dela com as operações incluídas. */
    function seedUploadkit(urls, tries) {
      if (!urls || !urls.length) return;
      var uk = window.UploadKit;
      if (!ukAvailable() || !uk || typeof uk.addFilesFromUuids !== 'function') {
        if ((tries || 0) > 10) return;
        setTimeout(function () { seedUploadkit(urls, (tries || 0) + 1); }, 300);
        return;
      }
      var uploader = uploaderConfig();
      if (!uploader || (uploader.files && uploader.files.length)) return;
      try { uk.addFilesFromUuids(uploader, urls); } catch (e) {}
    }

    function seedFromLine(line, lines) {
      var props = {};
      Object.keys(line.properties || {}).forEach(function (name) { props[name] = line.properties[name]; });
      /* o lugar, as coordenadas e a data vão à vista OU escondidos conforme o tipo (properties): lêem-se dos dois sítios */
      [[strings.prop_place_visible, strings.prop_place], [strings.prop_coordinates_visible, strings.prop_coordinates], [strings.prop_date_visible, strings.prop_date]].forEach(function (pair) {
        if (pair[0] && props[pair[0]] && !props[pair[1]]) props[pair[1]] = props[pair[0]];
      });
      var ours = ourPropertyNames();
      state.variantId = String(line.variant_id);
      if (sizeIndex > -1) state.size = String((variant().options || [])[sizeIndex] || ''); /* o tamanho é a variante que está no saco */

      /* comprimento do fio: o valor guardado é o rótulo do cartão, procura-se o cartão que o tem */
      if (props[strings.prop_chain]) {
        $$('[data-flow-chain]').forEach(function (card) {
          if (card.getAttribute('data-title') === props[strings.prop_chain]) state.chain = card.getAttribute('data-flow-chain');
        });
      }

      var e = state.engraving;
      Object.keys(strings.prop_type_values || {}).forEach(function (k) {
        if (strings.prop_type_values[k] === props[strings.prop_type]) e.type = k;
      });
      if (e.type) e.view = 'form';
      if (props[strings.prop_text]) e.text = props[strings.prop_text];
      if (e.type === 'morse' && props[strings.prop_morse_text]) e.text = props[strings.prop_morse_text]; /* o código refaz-se a partir do texto */
      Object.keys(strings.prop_font_values || {}).forEach(function (k) {
        if (strings.prop_font_values[k] === props[strings.prop_font]) e.font = k;
      });
      if (props[strings.prop_back_on_piece]) { e.back = true; e.backText = props[strings.prop_back_on_piece]; }
      if (props[strings.prop_place]) { e.place = props[strings.prop_place]; e.mapPlace = props[strings.prop_place]; e.mapLabel = props[strings.prop_place]; }
      if (props[strings.prop_coordinates] && props[strings.prop_coordinates] !== strings.prop_coordinates_pending) e.coords = props[strings.prop_coordinates];
      if (e.type === 'coordinates') {
        /* o ponto em números, para o mapa voltar a aparecer; o que se grava continua a ser o texto */
        try {
          var point = JSON.parse(props[strings.prop_map_data] || 'null');
          if (point && typeof point.lat === 'number' && typeof point.lng === 'number') { e.lat = point.lat; e.lng = point.lng; }
        } catch (err) {}
      }
      if (e.type === 'star_map') {
        /* O mapa volta do que se guardou em cru: a data e a hora à vista estão escritas para se lerem
           («12/08/2024», «22:00 (não indicada)») e um campo de data não as aceita, e as coordenadas à
           vista são graus com símbolos, não números. Sem os valores crus, editar abria com o lugar certo
           e a data vazia — e uma peça guardada assim perdia o céu. Quando não há, lê-se o que está à vista
           (mais abaixo); as coordenadas, essas, só voltam escolhendo o lugar nas sugestões. */
        var raw = null;
        try { raw = JSON.parse(props[strings.prop_map_data] || 'null'); } catch (err) { raw = null; }
        if (raw && typeof raw.lat === 'number' && typeof raw.lng === 'number') {
          e.mapLat = raw.lat; e.mapLng = raw.lng;
          e.date = raw.date || '';
          e.time = raw.time || '';
        }
        /* Sem os valores crus (o lugar foi escrito sem escolher uma sugestão, e aí não há coordenadas), a data e a hora
           lêem-se do que está à vista na linha: «12/08/2024» → 2024-08-12; a hora só se for uma hora escolhida («21:30»),
           não a de omissão («22:00 (não indicada)»). O cliente vê a noite como a deixou e muda o que quiser
           (pedido do utilizador, 28 Set). */
        if (!e.date) {
          var shownDate = String(props[strings.prop_date] || '').match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
          if (shownDate) e.date = shownDate[3] + '-' + shownDate[2] + '-' + shownDate[1];
        }
        var shownTime = String(props[strings.prop_time] || '').trim();
        if (!e.time && /^\d{2}:\d{2}$/.test(shownTime)) e.time = shownTime;
      } else {
        if (props[strings.prop_date]) e.date = props[strings.prop_date];
        if (props[strings.prop_time]) e.time = props[strings.prop_time];
      }

      /* Nem todas as peças têm todas as strings: as do desenho («prop_artwork») só existem nas de gravação.
         Sem esta guarda, comparar duas em falta dava «undefined === undefined» — verdadeiro — e uma peça de
         fotografia abria a dizer que a fotografia era para enviar depois. */
      var propIs = function (name, value) { return !!name && !!value && props[name] === value; };
      state.fineTune = propIs(strings.prop_fine_tune, strings.prop_fine_tune_value);
      state.sameTwice = propIs(strings.prop_same_twice, strings.prop_same_twice_value);

      /* tudo o que não é nosso é da app do upload: copia-se tal e qual, para voltar a gravar igual */
      var appProps = [];
      Object.keys(props).forEach(function (name) {
        if (ours.indexOf(name) > -1) return;
        /* as propriedades à vista da gravação (nome na língua da visita) não têm «_» nem link: não são da app */
        if (name.charAt(0) !== '_' && String(props[name]).indexOf('://') < 0) return;
        appProps.push({ name: name, value: props[name] });
      });
      /* As fotografias da peça TAL COMO ESTÃO NA LINHA. É com estas que se decide o que o cartão levava —
         nunca com state.photo.props, que a app reescreve assim que recebe os ficheiros de volta. */
      var pieceVisible = [];
      if (appProps.length) {
        state.photo.props = appProps;
        var visible = appProps.filter(function (p) { return p.name.charAt(0) !== '_'; });
        pieceVisible = visible;
        /* sem a moldura redonda que a app desenha por cima (-/overlay/…): o aro é nosso, em CSS, e no cartão
           a fotografia é impressa quadrada. É o mesmo que readUploadkit faz às miniaturas da app. */
        state.photo.thumbs = visible.map(function (p) {
          var direct = appProps.filter(function (d) { return d.name === '_' + p.name + ' (direct link)'; })[0];
          return withoutOverlay(direct ? direct.value : p.value);
        });
        state.photo.thumb = state.photo.thumbs[0] || '';
        state.photo.done = visible.length;
        state.photo.status = 'ready';
        /* E põem-se de volta DENTRO da app, senão «Trocar fotografia» e «Ajustar recorte» abriam-se vazios.
           Passa-se o endereço completo, com o recorte que o cliente fez, e não só o identificador do ficheiro.
           A app carrega depois da página, por isso tenta-se algumas vezes; se não der, fica-se com o que já
           se via — a fotografia aparece na janela, só não se pode afinar sem enviar outra. */
        state.editPhotos = visible.map(function (p) { return uploadkitSeedUrl(p.value); }).filter(Boolean);
      }

      /* extras: as linhas coladas a esta peça. A gravação no verso e o kit não são extras escolhidos —
         o verso já veio na propriedade e o kit entra sozinho com a impressão digital. */
      var backId = backExtra() ? String(backExtra().variant_id) : '';
      var kitId = kitExtra() ? String(kitExtra().variant_id) : '';
      var lensId = config.lens ? String(config.lens.variant_id) : '';
      state.lenses = { count: 0, active: 0, slots: [{ props: [], thumb: '' }, { props: [], thumb: '' }] };
      var keys = [line.key];
      /* o carrinho devolve as linhas da mais recente para a mais antiga: ao contrário, a «Lente 1» volta a ser a primeira */
      lines.slice().reverse().forEach(function (other) {
        var op = other.properties || {};
        if (!op[strings.prop_main_item] || op[strings.prop_key] !== props[strings.prop_key]) return;
        keys.push(other.key);
        var id = String(other.variant_id);
        if (id === backId || id === kitId) return;
        if (id === lensId) {
          var n = state.lenses.count;
          if (n > 1) return;
          state.lenses.count = Math.min(2, n + (other.quantity || 1));
          var lensProps = Object.keys(op).filter(function (k) { return k !== strings.prop_main_item && k !== strings.prop_key; }).map(function (k) { return { name: k, value: op[k] }; });
          var lensDirect = lensProps.filter(function (lp) { return /direct link/i.test(lp.name); })[0];
          state.lenses.slots[n] = { props: lensProps, thumb: lensDirect ? lensDirect.value : '' };
          return;
        }
        state.extras[id] = true;
        if (op[strings.prop_message]) state.message = op[strings.prop_message];
        /* o cartão com fotografia: ou é uma das fotografias da peça (a mesma, sem a moldura redonda)
           ou é uma que o cliente enviou só para o cartão. Volta escolhida como estava. */
        var cardValue = op[strings.prop_card_photo];
        if (!cardValue) return;
        var fromPiece = -1;
        pieceVisible.forEach(function (p, i) {
          if (withoutOverlay(p.value) === cardValue) fromPiece = i;
        });
        if (fromPiece > -1) {
          state.card = { source: 'piece', index: fromPiece, props: [], thumb: state.photo.thumbs[fromPiece] || '' };
        } else {
          var cardDirect = withoutOverlay(op['_' + strings.prop_card_photo + ' (direct link)'] || cardValue);
          state.card = {
            source: 'new',
            index: 0,
            props: [{ name: strings.prop_card_photo, value: withoutOverlay(cardValue) }, { name: '_' + strings.prop_card_photo + ' (direct link)', value: cardDirect }],
            thumb: cardDirect
          };
        }
      });
      /* Mapa das estrelas: o desenho do TeeInBlue já existe e vem nas três propriedades privadas da linha.
         Sem o repor, guardar mandava criar outro — e se a app falhasse, a linha nova ficava SEM o desenho,
         que a antiga tinha. Reposto com a chave dos dados de agora: se o cliente não mexer na data nem no
         lugar, é este que se volta a gravar; se mexer, a chave deixa de bater certo e cria-se um novo. */
      if (props[strings.prop_tib_id] && props[strings.prop_tib_image]) {
        e.sky = { id: props[strings.prop_tib_id], image: props[strings.prop_tib_image], link: props[strings.prop_tib_link] || '', key: skyInputs() };
      }
      /* «piece» é a chave da peça antiga (a propriedade «_Peça»): ao guardar, o que se tira do saco são as
         linhas que a tenham — e não só as que se viram aqui. Ver removeOldPiece. */
      state.edit = { key: line.key, keys: keys, piece: props[strings.prop_key] || '' };
      syncExtras();
      /* Só agora se devolvem as fotografias à app. Ela reescreve os valores assim que as recebe, e tudo o
         que se decide a partir da linha — nomeadamente qual das fotografias o cartão levava — já ficou
         decidido acima. Fazer isto mais cedo comparava contra os valores da app e falhava sempre. */
      seedUploadkit(state.editPhotos);
    }

    /* «memoria» = a personalização, seja ela fotografia, gravação ou céu.
       «extras» entra pela OFERTA (saco, cartão) e não pelo passo dos extras: é o primeiro dos dois e o
       cliente segue dali para a frente — decisão do utilizador, 24 Set. */
    function editStep(name) {
      if (name === 'lentes' && steps.indexOf('lenses') > -1) return 'lenses'; /* o «Editar» da lente, no saco */
      if (name === 'extras') return steps.indexOf('gift') > -1 ? 'gift' : 'extras';
      return steps.indexOf('photo') > -1 ? 'photo' : 'memory';
    }

    /* Quantos extras do pack já estão no saco: é esta a conta que a loja faz para aplicar os 50 %, e o fluxo
       tem de a fazer igual para não prometer um desconto que a caixa não dá (nem esconder um que ela dá).
       As linhas desta peça, quando se está a editar, não contam — vão ser substituídas pelas escolhas de agora.
       Até a resposta chegar vale o que já se sabia; não se espera por ela para abrir o fluxo. */
    function refreshCartBundle() {
      if (!bundleAvailable()) return;
      var ids = {};
      bundleExtras().forEach(function (x) { ids[String(x.product_id)] = true; });
      var mine = (state.edit && state.edit.keys) || [];
      fetch(config.cart.url + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) {
          if (!cart || !cart.items) return;
          var count = 0;
          cart.items.forEach(function (item) {
            if (!ids[String(item.product_id)] || mine.indexOf(item.key) > -1) return;
            count += item.quantity || 1;
          });
          if (count === state.cartBundle) return;
          state.cartBundle = count;
          syncBundle();
          renderFoot();
          if (state.step === 'review') renderReview();
        })
        .catch(function () {});
    }

    function openFromCart() {
      var params = new URLSearchParams(window.location.search);
      var wanted = params.get('engram_edit');
      if (!wanted) return;
      fetch(config.cart.url + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) {
          if (!cart || !cart.items) return;
          var line = cart.items.filter(function (i) { return i.key === wanted; })[0];
          if (!line || String(line.product_id) !== String(config.product.id)) return;
          open({ variantId: line.variant_id, line: line, lines: cart.items, step: editStep(params.get('engram_step')) });
          /* o endereço fica limpo: recarregar a página, ou voltar atrás, não reabre a edição de uma linha
             que entretanto pode já nem existir */
          try {
            params.delete('engram_edit');
            params.delete('engram_step');
            var rest = params.toString();
            history.replaceState(null, '', window.location.pathname + (rest ? '?' + rest : '') + window.location.hash);
          } catch (e) {}
        })
        .catch(function () {});
    }

    function open(detail) {
      /* Já aberto a editar uma peça do saco: um segundo pedido de abertura sem linha não vem do cliente.
         Vem da página — a app do mapa das estrelas agarra-se ao botão de compra e chega a dar o toque por
         nós quando trata do desenho, e o nosso ouvinte traduz esse toque em «abre o fluxo». Se passasse,
         `open` recomeçava do zero: os extras da peça que se está a editar desapareciam (a carta era a que
         mais dava por isso, por causa da mensagem) e a gravação no verso ficava sozinha. */
      if (state.edit && root.classList.contains('is-open') && !(detail && detail.line)) return;
      restore();
      /* oferta e extras começam sempre desligados ao abrir de novo (pedido do utilizador, 22 Set) */
      state.extras = {};
      state.message = '';
      state.card = { source: '', index: 0, props: [], thumb: '' };
      if (cardRoot && state.step !== 'added') resetCardUploader();
      syncExtras();
      if (detail && detail.variantId) state.variantId = String(detail.variantId);
      keepSize();
      state.opener = detail && detail.trigger ? detail.trigger : document.activeElement;
      /* o cartão da peça aparece em vários passos (fio, fotografia, gravação): pode haver mais do que um */
      renderPmini();
      closeGuide(true);
      root.hidden = false;
      root.offsetWidth; /* estado inicial antes da transição */
      root.classList.add('is-open');
      document.documentElement.classList.add('engram-flow-on');
      track('flow_open', { edit: !!state.edit });
      lockPage();
      fitViewport();
      if (state.step === 'added') {
        state.lenses = { count: 0, active: 0, slots: [{ props: [], thumb: '' }, { props: [], thumb: '' }] };
        state.step = steps[0]; state.extras = {}; state.message = ''; forget(); resetUploader(false); setPhotoStatus('empty');
        state.chain = steps.indexOf('chain') > -1 ? (chainOptions[0] || '') : '';
        state.size = '';
        state.engraving = { type: engravingTypes.length === 1 ? engravingTypes[0] : '', view: engravingTypes.length === 1 ? 'form' : 'type', text: '', font: 'script', place: '', coords: '', lat: null, lng: null, date: '', time: '', mapPlace: '', mapLabel: '', mapLat: null, mapLng: null, sky: null, back: false, backText: '' };
      }
      readUploadkit();
      /* a editar: o estado vem da linha do saco e não do que a app tem na página.
         Sem linha, o fluxo é uma compra normal — e tem de o ser mesmo que a anterior tenha sido uma edição
         descartada, senão guardar apagava a peça antiga sem ter sido pedido. */
      state.edit = null;
      state.editPhotos = null;
      state.restoring = false;
      if (detail && detail.line) {
        seedFromLine(detail.line, detail.lines || []);
        state.step = detail.step || steps[0];
      }
      refreshCartBundle(); /* o desconto dos extras depende do saco inteiro: pergunta-se sempre que o fluxo abre */
      /* «Como escolher a fotografia» na página de produto (1n): o fluxo abre no passo da fotografia, com o guia por cima */
      var withGuide = detail && detail.guide === 'photo' && guides.photo && steps.indexOf('photo') > -1;
      if (withGuide) state.step = 'photo';
      if (sizeIndex > -1 && !state.size) state.step = 'size'; /* sem tamanho (primeira vez, ou a cor nova não o tem) começa-se por ele */
      go(state.step);
      if (withGuide) openGuide('photo', null, true);
      /* a editar uma linha em que o lugar foi escrito sem escolher sugestão: procura-se já, para haver coordenadas
         (e o «Traçar o céu» no mapa) — fica a primeira sugestão, à vista por baixo do campo */
      if (state.edit && engraving) {
        var seeded = state.engraving;
        if (seeded.type === 'star_map' && seeded.mapPlace && seeded.mapLat === null && mapFinder) mapFinder.resolve(seeded.mapPlace);
        if (seeded.type === 'coordinates' && seeded.place && seeded.lat === null && placeFinder) placeFinder.resolve(seeded.place);
      }
    }
    /* guia «Como recolher a impressão?» (kit de cera): por cima do passo, dentro do painel; o resto fica inerte enquanto está aberto */
    /* e guia «Como escolher a fotografia» (1n): o mesmo mecanismo; no desktop o painel alarga para 760px enquanto está aberto.
       `guide` é o guia aberto (ou null). Aberto a partir da página de produto, fechar o guia fecha o fluxo. */
    var guides = { fp: $('[data-flow-fp-guide]'), stamp: $('[data-flow-stamp-guide]'), photo: $('[data-flow-guide="photo"]'), chain: $('[data-flow-guide="chain"]'), size: $('[data-flow-guide="size"]'), extra: $('[data-flow-guide="extra"]') };
    /* «Sobre o extra»: a folha com a fotografia grande, o preço e a descrição do extra (Fábio, 29 Out 2026) */
    function openExtraInfo(id, opener) {
      var x = null;
      config.extras.forEach(function (e) { if (String(e.variant_id) === String(id)) x = e; });
      var el = guides.extra;
      if (!x || !el) return;
      var fig = el.querySelector('[data-flow-extra-info-figure]');
      var img = el.querySelector('[data-flow-extra-info-img]');
      var src = x.image_large || x.image || '';
      if (img) img.src = src;
      if (fig) fig.hidden = !src;
      el.querySelector('[data-flow-extra-info-title]').textContent = x.title;
      el.querySelector('[data-flow-extra-info-price]').textContent = fmt(x.price);
      var text = el.querySelector('[data-flow-extra-info-text]');
      text.textContent = x.description || '';
      text.hidden = !x.description;
      openGuide('extra', opener);
    }
    var guide = null;
    var guideOpener = null;
    var guideAlone = false;
    function openGuide(name, opener, alone) {
      var el = guides[name];
      if (!el) return;
      if (guide && guide !== el) closeGuide(true);
      guide = el;
      guideOpener = opener || null;
      guideAlone = !!alone;
      el.hidden = false;
      dialog.classList.toggle('is-guide-photo', name === 'photo');
      dialog.classList.toggle('is-guide-extra', name === 'extra'); /* no desktop a folha «Sobre o extra» dá a altura ao painel, como o guia da fotografia */
      /* o rótulo do botão diz o que ele faz: só «Entendi» dentro do painel */
      Array.prototype.forEach.call(el.querySelectorAll('[data-flow-guide-choose]'), function (button) {
        var label = button.getAttribute(guideAlone ? 'data-label-choose' : 'data-label-back');
        if (label) button.textContent = label;
      });
      Array.prototype.forEach.call(dialog.children, function (child) { if (child !== el) child.inert = true; });
      var scroller = el.querySelector('.engram-flow__guide-body');
      if (scroller) scroller.scrollTop = 0;
      el.focus();
    }
    function closeGuide(quiet) {
      if (!guide || guide.hidden) { guide = null; return; }
      guide.hidden = true;
      guide = null;
      dialog.classList.remove('is-guide-photo');
      dialog.classList.remove('is-guide-extra');
      Array.prototype.forEach.call(dialog.children, function (el) { el.inert = false; });
      if (!quiet && guideOpener) guideOpener.focus();
      guideOpener = null;
      guideAlone = false;
    }
    /* × ou Esc: aberto a partir da página, fecha tudo; aberto dentro do fluxo, volta ao passo */
    function dismissGuide() {
      if (guideAlone) { closeGuide(true); close(); return; }
      closeGuide();
    }
    function close() {
      closeGuide(true);
      root.classList.remove('is-open');
      document.documentElement.classList.remove('engram-flow-on');
      unlockPage();
      fitViewport();
      setTimeout(function () { if (!root.classList.contains('is-open')) root.hidden = true; }, 420);
      if (state.opener && typeof state.opener.focus === 'function') state.opener.focus();
    }

    /* ---------- teclado do telemóvel (ecrã 1o-03) ----------
       O painel fica do tamanho da parte do ecrã que se vê (visualViewport): com o teclado aberto encolhe até ele e a barra
       «Continuar» fica logo por cima, na palavra, no verso, na carta, em qualquer campo. Visto em prints do iPhone 13
       (28 Set, pedido do utilizador): com o painel a ocupar o ecrã inteiro, a barra ora ficava atrás do teclado, ora tapada
       pela barra do iOS.
       Scroll com o teclado aberto: o conteúdo desliza livre entre o topo e a barra. O campo com o foco só se traz à vista
       quando o painel ENCOLHE (o teclado a abrir) e só se ficou escondido — nunca durante o scroll, senão o conteúdo
       saltava de volta para o campo a cada movimento (o iOS avisa «scroll» do visualViewport enquanto se desliza). */
    var vv = window.visualViewport;
    var lastVvHeight = 0;
    function revealField() {
      var active = document.activeElement;
      if (!active || !body.contains(active) || !active.matches('input, textarea')) return;
      var box = body.getBoundingClientRect();
      var field = active.getBoundingClientRect();
      var gap = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--space-3')) || 0;
      if (field.bottom > box.bottom) body.scrollTop += field.bottom - box.bottom + gap;
      else if (field.top < box.top) body.scrollTop -= box.top - field.top + gap;
    }
    function fitViewport() {
      if (!vv || !MOBILE.matches || !root.classList.contains('is-open')) {
        root.style.removeProperty('--flow-vv-h');
        root.style.removeProperty('--flow-vv-top');
        lastVvHeight = 0;
        return;
      }
      var height = Math.round(vv.height);
      var shrank = lastVvHeight > 0 && height < lastVvHeight;
      lastVvHeight = height;
      root.style.setProperty('--flow-vv-h', height + 'px');
      root.style.setProperty('--flow-vv-top', Math.round(vv.offsetTop) + 'px');
      if (shrank) revealField();
    }
    if (vv) { vv.addEventListener('resize', fitViewport); vv.addEventListener('scroll', fitViewport); }

    /* ---------- página congelada enquanto o fluxo está aberto ----------
       Como o drawer do tema activo (body.pa-personalization-open: position fixed + overflow hidden + overscroll none):
       com o body fixo, o iOS não tem documento para deslizar quando o teclado abre. Guarda-se o scroll e repõe-se ao fechar.
       Decisão do utilizador (23 Set): o fluxo fica com o comportamento do tema activo — no iPhone a barra «Continuar» sobe
       com o teclado (é o Safari a arrastar o que é fixed; o vecinocustom.com faz o mesmo) e aceita-se. */
    var lockedScrollY = null;
    function lockPage() {
      if (lockedScrollY !== null) return;
      lockedScrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
      var b = document.body;
      b.style.position = 'fixed'; b.style.top = -lockedScrollY + 'px'; b.style.left = '0'; b.style.right = '0'; b.style.width = '100%';
    }
    function unlockPage() {
      if (lockedScrollY === null) return;
      var b = document.body, y = lockedScrollY;
      lockedScrollY = null;
      b.style.position = ''; b.style.top = ''; b.style.left = ''; b.style.right = ''; b.style.width = '';
      window.scrollTo(0, y);
    }

    /* ---------- adicionar ao saco: a peça + um item por extra, de uma vez ---------- */
    function properties() {
      var props = {};
      /* o comprimento do fio não é variante: vai como propriedade de linha, visível na encomenda (plano §3.3) */
      if (chainLabel()) props[strings.prop_chain] = chainLabel();
      if (engraving) {
        var e = state.engraving;
        /* Colar Morse: exactamente as duas propriedades que o tema activo escreve e o atelier lê — «Texto original» tal como foi
           escrito («Pai Mãe Eu») e «Código Morse» («.--. .- .. / -- .- . / . ..-»). Sem «Tipo de gravação»: não é uma gravação. */
        if (e.type === 'morse') {
          props[strings.prop_morse_text] = e.text.trim();
          props[strings.prop_morse_code] = morseCode();
          return props;
        }
        props[strings.prop_type] = strings.prop_type_values[e.type];
        if (e.type === 'text') { props[strings.prop_text] = e.text.trim(); props[strings.prop_font] = strings.prop_font_values[e.font]; }
        if (e.type === 'coordinates') {
          props[strings.prop_place] = e.place.trim();
          props[strings.prop_coordinates_visible] = e.coords.trim() || strings.prop_coordinates_pending; /* à vista; o lugar fica escondido */
          /* e o ponto em números, para a edição voltar a ter o mapa (o que está à vista são graus com
             símbolos, que não voltam a ser uma coordenada) — a mesma propriedade do mapa das estrelas */
          if (e.lat !== null && e.lng !== null) props[strings.prop_map_data] = JSON.stringify({ lat: e.lat, lng: e.lng });
        }
        if (e.type === 'star_map') {
          props[strings.prop_date_visible] = dateLabel(e.date.trim()); /* mapa: lugar e data à vista; hora e coordenadas escondidas */
          props[strings.prop_time] = e.time.trim() || fill(strings.prop_time_default, { time: skyTime() });
          props[strings.prop_place_visible] = e.mapLabel || e.mapPlace.trim();
          if (e.mapLat !== null && e.mapLng !== null) props[strings.prop_coordinates] = formatCoordinate(e.mapLat, true) + ', ' + formatCoordinate(e.mapLng, false);
          /* E o mesmo em cru, para a edição a partir do saco. O que fica à vista está escrito para se ler
             («12/08/2024», «22:00 (não indicada)», «38,7078° N») e não volta a entrar num campo de data
             nem numa conta de coordenadas: sem isto, editar a peça abria com o lugar certo e a data vazia. */
          if (e.mapLat !== null && e.mapLng !== null) {
            props[strings.prop_map_data] = JSON.stringify({ lat: e.mapLat, lng: e.mapLng, date: e.date.trim(), time: e.time.trim() });
          }
          /* o design do TeeInBlue, como no tema activo: só as três propriedades privadas que a produção usa */
          if (skyCurrent()) { props[strings.prop_tib_id] = e.sky.id; props[strings.prop_tib_image] = e.sky.image; props[strings.prop_tib_link] = e.sky.link; }
        }
        if (e.type === 'artwork') {
          /* os links da app, sem a moldura redonda (-/overlay/…) que a app põe para a janela da microfotografia: o desenho vai
             para uma placa quadrada — o mesmo tratamento da fotografia do cartão (1e) */
          state.photo.props.forEach(function (p) { props[p.name] = withoutOverlay(p.value); });
        }
        if (backOn()) props[strings.prop_back_on_piece] = e.backText.trim(); /* também na peça, para o atelier ver as duas faces juntas */
        return props;
      }
      state.photo.props.forEach(function (p) { props[p.name] = p.value; }); /* tal como a app as escreveu */
      if (state.fineTune) props[strings.prop_fine_tune] = strings.prop_fine_tune_value;
      if (dual && state.sameTwice && state.photo.done === 1) props[strings.prop_same_twice] = strings.prop_same_twice_value;
      return props;
    }
    function addToBag() {
      if (state.adding) return;
      state.adding = true; state.addError = false;
      renderFoot();
      /* mapa das estrelas: o design do TeeInBlue cria-se (ou confirma-se) com os dados finais antes de adicionar, como no tema activo */
      var prepare = engraving && state.engraving.type === 'star_map' ? ensureSky().catch(function () { return null; }) : Promise.resolve(null);
      prepare.then(function () { addToBagNow(); });
    }
    /* Tirar do saco a peça que se estava a editar, agora que a nova já lá está — uma linha de cada vez.
       Custou caro descobrir porquê: a chave de uma linha do carrinho NÃO é estável. Muda quando muda o
       que a Shopify lhe aplica — e tirar uma linha muda o desconto dos extras (que conta os artigos do
       saco), o que dá chaves novas às linhas que ficam. Pedir as quatro de uma vez, com as chaves que se
       leram ao abrir, tirava as duas primeiras e falhava as outras EM SILÊNCIO: os extras da peça antiga
       ficavam para trás, órfãos e a serem cobrados — era isto que fazia a carta escrita à mão «desaparecer»
       da peça. Por isso: lê-se o saco, tira-se a primeira linha da peça antiga, e é a resposta dessa
       chamada (que já traz o saco) que diz qual é a próxima. Nunca se reaproveita uma chave lida antes.
       Devolve a última resposta, que é a que traz as secções com que o saco se desenha. */
    function removeOldPiece(edit, payload, fallback) {
      var last = fallback;
      function nextTarget(cart) {
        if (!cart || !cart.items) return null;
        for (var i = 0; i < cart.items.length; i++) {
          var item = cart.items[i];
          if (edit.piece) {
            if ((item.properties || {})[strings.prop_key] === edit.piece) return item;
          } else if (edit.keys.indexOf(item.key) > -1) {
            return item;
          }
        }
        return null;
      }
      function step(cart, left) {
        var target = left > 0 ? nextTarget(cart) : null;
        if (!target) return Promise.resolve(last);
        var body = { id: target.key, quantity: 0 };
        if (payload.sections) { body.sections = payload.sections; body.sections_url = payload.sections_url; }
        return fetch(config.cart.change_url + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify(body)
        })
          .then(function (response) { return response.json().then(function (data) { return { ok: response.ok, data: data }; }); })
          .then(function (result) {
            if (!result.ok || result.data.status) throw new Error(result.data.description || result.data.message || 'cart');
            last = result;
            return step(result.data, left - 1);
          });
      }
      return fetch(config.cart.url + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cartNow) { return step(cartNow, 12); });
    }

    /* classe de produção (SLA) da peça, para o Pod Hero: «_sla_class» = S0…S5 na linha da peça e em todos os extras ligados
       a ela (verso, kit, cartão, ofertas, lentes). A tabela vem de snippets/engram-sla-class (metaobjecto «Engram · SLA»);
       na Gravura conta a forma escolhida: texto e coordenadas S1, desenho e mapa S2, impressão digital com carimbo S4. */
    function slaClass() {
      var sla = config.sla || {};
      var type = config.type || 'nenhuma';
      var kind = type === 'gravacao' ? state.engraving.type : (type === 'mapa_estrelas' ? 'star_map' : type);
      return sla[kind] || (type === 'gravacao' ? sla.text : '') || sla.nenhuma || 'S0';
    }

    function addToBagNow() {
      var key = state.variantId + '-' + Date.now().toString(36);
      var piece = properties();
      piece[strings.prop_key] = key;
      piece._sla_class = slaClass();
      var items = [{ id: parseInt(state.variantId, 10), quantity: 1, properties: piece }];
      var linked = function (extra) {
        var p = {};
        p[strings.prop_main_item] = config.product.title;
        p[strings.prop_key] = key;
        p._sla_class = piece._sla_class;
        return { id: extra.variant_id, quantity: 1, properties: p };
      };
      /* gravação no verso: linha própria com o texto do verso; kit de impressão digital: linha a 0 € */
      if (backOn()) { var backItem = linked(backExtra()); backItem.properties[strings.prop_back_on_piece] = state.engraving.backText.trim(); items.push(backItem); }
      if (kitExtra()) {
        var kitItem = linked(kitExtra());
        /* kit de cera: quantas impressões recolher, na linha do kit — como no tema activo («_Número de gravações») */
        if (countIndex > -1) kitItem.properties['_' + strings.prop_count] = String(fpCount());
        items.push(kitItem);
      }
      selectedExtras().forEach(function (x) {
        var item = linked(x);
        if (x.message && state.message.trim()) item.properties[strings.prop_message] = state.message.trim();
        if (x.photo) {
          /* cartão com fotografia: os mesmos links da app (a fotografia da peça, ou a nova), como no tema activo */
          var picked = cardChosen();
          /* o link directo segue a convenção da app: «_<nome> (direct link)» */
          if (picked) { item.properties[strings.prop_card_photo] = picked.value; if (picked.direct) item.properties['_' + strings.prop_card_photo + ' (direct link)'] = picked.direct; }
        }
        items.push(item);
      });
      if (lensOn()) items = items.concat(lensItems(linked));
      var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      var payload = { items: items };
      if (cart && typeof cart.getSectionsToRender === 'function') {
        payload.sections = cart.getSectionsToRender().map(function (s) { return s.id; }).join(',');
        payload.sections_url = window.location.pathname;
      }
      fetch(config.cart.add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(payload)
      })
        .then(function (response) { return response.json().then(function (data) { return { ok: response.ok, data: data }; }); })
        .then(function (result) {
          if (!result.ok || result.data.status) throw new Error(result.data.description || result.data.message || 'cart');
          /* A editar (1o-06): a peça nova já está no saco — só agora se tira a antiga e os extras dela.
             Por esta ordem de propósito: se a rede falhar a meio, o cliente fica com a peça a mais e não
             com o saco vazio. O que se desenha no saco é a resposta desta segunda chamada, que já é a final. */
          if (!state.edit) return result;
          return removeOldPiece(state.edit, payload, result);
        })
        .then(function (result) {
          if (!result.ok || result.data.status) throw new Error(result.data.description || result.data.message || 'cart');
          if (cart && typeof cart.renderContents === 'function' && result.data.sections) {
            /* o passo «Adicionado» é o do fluxo: o drawer actualiza-se mas não se abre por cima */
            var opens = cart.classList.contains('open-after-adding');
            if (opens) cart.classList.remove('open-after-adding');
            try { cart.renderContents(result.data); } catch (e) {}
            if (opens) cart.classList.add('open-after-adding');
          }
          // PUB_SUB_EVENTS é um «const» do assets/global.js: existe pelo nome, não como window.PUB_SUB_EVENTS (testes de 19 Out)
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'engram-flow', productVariantId: state.variantId });
          return fetch(config.cart.url + '.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
        })
        .then(function (cartData) {
          state.added = cartData;
          state.adding = false;
          track('flow_add_to_cart', { variant_id: state.variantId, value: total() / 100, currency: (cartData && cartData.currency) || '', edit: !!state.edit });
          forget();
          go('added');
        })
        .catch(function () {
          state.adding = false; state.addError = true;
          /* a editar, a mensagem é a de guardar alterações (a peça no saco fica como estava) */
          var errorText = $('[data-flow-add-error-text]');
          if (errorText) errorText.textContent = errorText.getAttribute(state.edit ? 'data-text-edit' : 'data-text');
          $('[data-flow-add-error]').hidden = false;
          renderFoot();
        });
    }

    /* ---------- eventos ---------- */
    document.addEventListener('engram:flow:open', function (event) { open(event.detail || {}); });
    /* a Key (ecrã 6d): o saco (assets/engram-cart.js) junta-a ou tira-a depois de a peça entrar; no «Adicionado»
       relê-se o saco para o cartão da Key e a linha do saco dizerem o que lá está */
    if ($('[data-flow-added-key]') && typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (state.step !== 'added' || !event || event.source !== 'engram-cart') return;
        fetch(config.cart.url + '.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (cartData) { if (cartData && state.step === 'added') { state.added = cartData; renderAdded(); } })
          .catch(function () {});
      });
    }
    /* medição: «Finalizar compra» do passo «Adicionado» (o do saco está em assets/engram-cart.js) */
    root.addEventListener('click', function (event) {
      if (event.target.closest && event.target.closest('[data-flow-checkout]')) track('checkout_click', { source: 'flow_added' });
    });
    /* chegou-se aqui a partir do «Editar» do saco? então abre-se já, preenchido, no passo pedido */
    openFromCart();
    root.addEventListener('click', function (event) {
      var t = event.target;
      if (t.closest('[data-flow-close]')) { close(); return; }
      /* «Descartar alterações» (1o-06): fecha sem tocar no saco — a peça fica como estava */
      if (t.closest('[data-flow-discard]')) { close(); return; }
      if (t.closest('[data-flow-back]')) { backward(); return; }
      if (t.closest('[data-flow-next]')) { forward(); return; }
      if (t.closest('[data-flow-keep]')) { close(); return; }
      var more = t.closest('[data-flow-review-more]');
      if (more) { var sub = more.closest('.engram-flow__review-sub'); var open = sub.classList.toggle('is-clamped'); more.textContent = more.getAttribute(open ? 'data-label' : 'data-label-less'); return; }
      var goTo = t.closest('[data-flow-go]');
      if (goTo) { go(goTo.getAttribute('data-flow-go')); return; }
      /* gravação: a forma, o tipo de letra, o verso */
      var sizeChip = t.closest('[data-flow-size]');
      if (sizeChip) { if (setSize(sizeChip.getAttribute('data-flow-size'))) { renderSize(); renderPmini(); renderFoot(); } return; }
      var chainCard = t.closest('[data-flow-chain]');
      if (chainCard) { state.chain = chainCard.getAttribute('data-flow-chain'); renderChain(); renderFoot(); return; }
      var fpCard = t.closest('[data-flow-fp-count]');
      if (fpCard) { setFpCount(Number(fpCard.getAttribute('data-flow-fp-count'))); renderEngraving(); renderPmini(); renderFoot(); return; }
      if (t.closest('[data-flow-fp-guide-open]')) { openGuide('fp', t.closest('[data-flow-fp-guide-open]')); return; }
      if (t.closest('[data-flow-fp-guide-close]')) { closeGuide(); return; }
      /* guia do kit de carimbo (Gravura em prata): o mesmo mecanismo do guia de cera */
      if (t.closest('[data-flow-stamp-guide-open]')) { openGuide('stamp', t.closest('[data-flow-stamp-guide-open]')); return; }
      if (t.closest('[data-flow-stamp-guide-close]')) { closeGuide(); return; }
      if (t.closest('[data-flow-guide-open]')) { var gOpen = t.closest('[data-flow-guide-open]'); openGuide(gOpen.getAttribute('data-flow-guide-open'), gOpen); return; }
      if (t.closest('[data-flow-guide-close]')) { dismissGuide(); return; }
      /* Guia aberto dentro do painel: «Entendi» só fecha o guia e volta ao passo da fotografia (pedido do utilizador, 28 Set).
         Aberto a partir da página: «Entendi. Escolher uma fotografia» fecha e abre logo o diálogo da app. */
      if (t.closest('[data-flow-guide-choose]')) {
        if (!guideAlone) { closeGuide(); return; }
        closeGuide(true);
        if (state.step !== 'photo') go('photo');
        openDialog(state.photo.status === 'error');
        return;
      }
      var typeCard = t.closest('[data-flow-type]');
      if (typeCard) { state.engraving.type = typeCard.getAttribute('data-flow-type'); renderEngraving(); renderFoot(); save(); return; }
      var font = t.closest('[data-flow-font]');
      if (font) { state.engraving.font = font.getAttribute('data-flow-font'); renderEngraving(); save(); return; }

      if (t.closest('[data-flow-sky-preview]')) { showSky(); return; }
      if (t.closest('[data-flow-back-toggle]')) {
        state.engraving.back = !state.engraving.back;
        renderEngraving(); renderFoot(); save(); /* sem focar o campo: no telemóvel abria logo o teclado (pedido do utilizador, 23 Set) */
        return;
      }
      if (t.closest('[data-flow-photo-choose]')) { openDialog(state.photo.status === 'error'); return; } /* com duas fotografias, já guardadas, reabre o diálogo para ajustar */
      if (t.closest('[data-flow-photo-change]')) { openDialog(true); return; }
      if (t.closest('[data-flow-photo-adjust]')) { openDialog(false); return; }
      if (t.closest('[data-flow-photo-cancel]')) {
        var uploader = uploaderConfig();
        var pending = uploader && uploader.files ? uploader.files.filter(function (f) { return !f.fileInfo; }) : [];
        pending.forEach(function (f) { try { f.ucObject.cancel(); } catch (e) {} });
        resetUploader(true);
        return;
      }
      var lensPick = t.closest('[data-flow-lens-count]');
      if (lensPick) { state.lenses.count = parseInt(lensPick.getAttribute('data-flow-lens-count'), 10) || 0; renderLenses(); renderFoot(); return; }
      var lensSlot = t.closest('[data-flow-lens-slot]');
      if (lensSlot) { openLensDialog(parseInt(lensSlot.getAttribute('data-flow-lens-slot'), 10) || 0); return; }
      if (t.closest('[data-flow-fine-tune]')) { state.fineTune = !state.fineTune; renderPhoto(); save(); return; }
      if (t.closest('[data-flow-same-twice]')) { state.sameTwice = !state.sameTwice; renderPhoto(); renderFoot(); renderProgress(); save(); return; }
      var pick = t.closest('[data-flow-photocard-pick]');
      if (pick) { state.card.source = 'piece'; state.card.index = parseInt(pick.getAttribute('data-flow-photocard-pick'), 10) || 0; renderCard(); renderFoot(); return; }
      if (t.closest('[data-flow-photocard-replace]')) { openCardDialog(); return; } /* «Substituir foto» */
      if (t.closest('[data-flow-photocard-new]')) {
        /* com fotografia, tocar escolhe-a; sem fotografia, abre logo o diálogo */
        if (state.card.props.length) { state.card.source = 'new'; renderCard(); renderFoot(); }
        else openCardDialog();
        return;
      }
      /* pack dos extras: liga os 4 de uma vez (ou desliga os 4, se já estavam todos) */
      if (t.closest('[data-flow-bundle]')) {
        var allOn = !bundleAllPicked();
        bundleExtras().forEach(function (x) { state.extras[x.variant_id] = allOn; });
        syncExtras(); renderCard(); renderFoot(); save();
        return;
      }
      /* a fotografia e o «i» do extra abrem a folha «Sobre o extra», não ligam o extra */
      var infoBtn = t.closest('[data-flow-extra-info]');
      if (infoBtn) { openExtraInfo(infoBtn.getAttribute('data-flow-extra-info'), infoBtn); return; }
      /* tocar no cartão inteiro liga/desliga, não só no interruptor (as caixas por baixo — mensagem, fotografia do cartão, verso — não contam) */
      var toggle = t.closest('[data-flow-extra-toggle]');
      if (!toggle) { var row = t.closest('[data-flow-extra] > .engram-flow__opt'); if (row) toggle = row.querySelector('[data-flow-extra-toggle]'); }
      if (!t.closest('[data-flow-fine-tune], [data-flow-same-twice], [data-flow-back-toggle]')) {
        var optRow = t.closest('[data-flow-opt]');
        var optSwitch = optRow && optRow.querySelector('[data-flow-fine-tune], [data-flow-same-twice], [data-flow-back-toggle]');
        if (optSwitch) { optSwitch.click(); return; }
      }
      if (toggle) {
        var id = toggle.getAttribute('data-flow-extra-toggle');
        state.extras[id] = !state.extras[id];
        syncExtras(); renderCard(); renderFoot(); save(); /* a carta abre a caixa da mensagem mas não foca: no telemóvel abria logo o teclado (pedido do utilizador, 23 Set) */
      }
    });
    /* campos da gravação: o estado acompanha o que se escreve; a pré-visualização e o contador também */
    root.addEventListener('input', function (event) {
      var t = event.target;
      if (!engraving || !t.matches || !t.matches('[data-flow-text-input], [data-flow-morse-input], [data-flow-place-input], [data-flow-back-input], [data-flow-date-input], [data-flow-time-input], [data-flow-map-place-input]')) return;
      if (t.hasAttribute('data-flow-text-input')) state.engraving.text = t.value;
      /* Colar Morse: só letras, números e espaços — o resto (pontuação, emojis) sai logo ao escrever, como no tema activo */
      if (t.hasAttribute('data-flow-morse-input')) { state.engraving.text = window.EngramMorse ? window.EngramMorse.clean(t.value) : t.value; if (t.value !== state.engraving.text) t.value = state.engraving.text; }
      /* lugar novo: o ponto antigo deixa de valer. Sem isto, escrever outro sítio por cima ficava com as
         coordenadas do anterior — e a peça saía gravada com um ponto que não é o lugar que lá está
         escrito. Escolhendo nas sugestões volta tudo; sem escolher, a linha vai «a confirmar», que é o
         que o atelier já sabe tratar. (O mesmo cuidado do lugar do mapa das estrelas.) */
      if (t.hasAttribute('data-flow-place-input')) {
        state.engraving.place = t.value;
        state.engraving.coords = ''; state.engraving.lat = null; state.engraving.lng = null;
      }
      if (t.hasAttribute('data-flow-map-place-input')) { state.engraving.mapPlace = t.value; state.engraving.mapLat = null; state.engraving.mapLng = null; state.engraving.mapLabel = ''; } /* lugar novo: escolhe-se de novo nas sugestões */
      if (t.hasAttribute('data-flow-date-input')) state.engraving.date = t.value;
      if (t.hasAttribute('data-flow-time-input')) state.engraving.time = t.value;
      if (t.hasAttribute('data-flow-back-input')) state.engraving.backText = t.value;
      renderEngraving(); renderFoot(); save();
    });
    root.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && guide && !guide.hidden) { event.preventDefault(); dismissGuide(); return; } /* Esc fecha o guia, não o fluxo (salvo se o guia abriu sozinho, da página) */
      if (event.key === 'Escape') { event.preventDefault(); close(); return; }
      /* Enter num campo da gravação = «Continuar», como num formulário */
      /* Enter no lugar das coordenadas = procurar no mapa; nos outros campos = «Continuar», como num formulário */
      if (event.key === 'Enter' && event.target.matches && event.target.matches('[data-flow-place-input], [data-flow-map-place-input]')) return; /* o procurador de lugares trata do Enter */
      if (event.key === 'Enter' && event.target.matches && event.target.matches('[data-flow-text-input], [data-flow-morse-input], [data-flow-back-input], [data-flow-date-input], [data-flow-time-input]')) { event.preventDefault(); forward(); return; }
      /* grupos de rádio (formas de gravar, tipo de letra, fotografia do cartão): setas mudam a opção */
      var radio = event.target.closest && event.target.closest('[role="radio"]');
      if (radio && radio.hasAttribute('data-flow-photocard-new') && event.target === radio && (event.key === 'Enter' || event.key === ' ')) { event.preventDefault(); radio.click(); return; }
      if (radio && /^Arrow(Up|Down|Left|Right)$/.test(event.key)) {
        event.preventDefault();
        var group = radio.closest('[role="radiogroup"], [data-flow-photocard]');
        var radios = group ? Array.prototype.slice.call(group.querySelectorAll('[role="radio"]')) : [radio];
        var i = radios.indexOf(radio);
        var next_i = (i + (/Down|Right/.test(event.key) ? 1 : radios.length - 1)) % radios.length;
        var to = radios[next_i];
        if (!to.hasAttribute('data-flow-photocard-new')) to.click(); /* a opção ganha o estado; a «outra fotografia» só ganha o foco (abre o diálogo com Enter) */
        var again = group ? Array.prototype.slice.call(group.querySelectorAll('[role="radio"]')) : radios; /* renderCard volta a desenhar as opções: procura-se de novo pelo índice */
        (again[next_i] || to).focus();
        return;
      }
      if (event.key !== 'Tab') return;
      var focusable = Array.prototype.filter.call(dialog.querySelectorAll('button:not([disabled]), a[href], textarea, input:not([type="hidden"]), [tabindex="0"]'), function (el) {
        return el.offsetParent !== null && !el.closest('[hidden]') && !el.closest('[inert]') && el.getAttribute('tabindex') !== '-1';
      });
      if (!focusable.length) return;
      var first = focusable[0], last = focusable[focusable.length - 1];
      if (event.shiftKey && (document.activeElement === first || document.activeElement === dialog)) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
    MOBILE.addEventListener('change', function () { if (!root.hidden) renderPhoto(); });
  }

  ready(function () {
    Array.prototype.forEach.call(document.querySelectorAll('[data-engram-flow]'), init);
  });
})();
